import React, { Component, Fragment } from "react";
import Moment from "react-moment";
import { SelectBox } from "devextreme-react/select-box";
import {
  formatTime,
  timeDiffCalc,
  formatDate,
  getRequestParams,
  parseBoolean,
} from "../../helpers/globalfunctions";
import { toast } from "react-toastify";
import Modal from "react-modal";
import NumberFormat from "react-number-format";
import Swal from "sweetalert2";
import DateBox from "devextreme-react/date-box";
//import exportFromJSON from 'export-from-json';
import "react-toastify/dist/ReactToastify.css";
//import ReactExport from 'react-data-export';
import Excel from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import {
  getVehicleLabelByIndustry,
  getLocalizedString,
  isNullOrEmpty,
  subString2,
  getBaseApiUrl,
} from "../../helpers/globalfunctions.js";
import secureLocalStorage from "react-secure-storage";

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
// const ExcelCell = ReactExport.ExcelFile.ExcelCell;

let currentTime =
  secureLocalStorage.getItem("session_locationTime") == ""
    ? new Date()
    : new Date(secureLocalStorage.getItem("session_locationTime"));
const customStyles = {
  content: {
    width: "50%",
    //height:'600px'
  },
};

const excelStyle = {
  font: { sz: "18", bold: true },
};

const VEHICLE_DETAILS_LABEL = getLocalizedString("Vehicle", " Details");
const VEHICLE_DETAILS_LABEL_BASE_LOCATION = getLocalizedString(
  "Base Location",
  ""
);
const SUPERVISOR_NAME_LABEL = getLocalizedString("Supervisor Name", "");
const SUPERVISOR_MOBILE_NO_LABEL = getLocalizedString(
  "Supervisor Mobile No",
  ""
);

var excelDataValues = [];
export class VehicleInfoComponent extends Component {
  static displayName = VehicleInfoComponent.name;

  constructor(props) {
    currentTime =
      secureLocalStorage.getItem("session_locationTime") == ""
        ? new Date()
        : new Date(secureLocalStorage.getItem("session_locationTime"));
    super(props);
    this.state = {
      infoWindow: "none",
      infoConfiguration: "none",
      infoVehicle: "block",
      vehicleDetails: null,
      overSpeedLimit: 0,
      dropdownVehicleIcon: [],
      dropdownDriver: [],
      isShowOverspeed: false,
      isShowVehicleIcon: false,
      isShowDriver: false,
      isShowCommandIcon: false,
      vehicleIconId: 0,
      driverId: 0,
      vehicleIcon: "Set Icon",
      vehicleDriverName: "Change/Assign Driver",
      selVehicleIcon: "",
      selDriverName: "",
      vehicleButtonPanelStatus: {},
      driverModalIsOpen: false,
      vehicleId: 0,
      id: 0,
      licenceNumber: "",
      OptionList: [
        { id: 1, name: "Engine Off" },
        { id: 2, name: "Engine No" },
      ],
      driverName: "",
      driverLName: "",
      mobileNumber1: "",
      mobileNumber2: "",
      email: "",
      city: "",
      immobilizerModalIsOpen: false,
      dState: "",
      address: "",
      driverKey: "",
      expDate: moment(currentTime).format("MM/DD/YYYY"),
      isActive: true,
      vehicleImage: "../assets/img/news/img08.jpg?v=1.0",
      startTime: moment(currentTime).format("MM/DD/YYYY") + " 00:00",
      endTime: moment(currentTime).format("MM/DD/YYYY hh:mm"),
      downloadDataSet: [],
      downloadDataFields: [],
      downloadDataValues: [],
      deviceTabOpen: parseBoolean(
        secureLocalStorage.getItem("session_isJobTripServiceAccount")
      )
        ? "show"
        : "",
      showVehicleImage: parseBoolean(
        secureLocalStorage.getItem("session_isJobTripServiceAccount")
      )
        ? false
        : true,
      Number1Dialed: "",
      Number2Dialed: "",
      errors: {
        licenceNumber: "",
        driverName: "",
        driverLName: "",
        mobileNumber1: "",
        mobileNumber2: "",
        email: "",
        city: "",
        dState: "",
        address: "",
        driverKey: "",
        expDate: "",
        gpsCommandId: "",
      },
      batteryPercentageClass: "",
      hostStatusTimeLabel: "",
      hostStatusClass: "",
      hostStatusTitleClass: "",
      driverMobileShowHide: false,
      industryTypeId: Number(
        secureLocalStorage.getItem("session_industryTypeId")
      ),
      currentDialingMobNo: null,
      isDialing1: false,
      isDialing2: false,
      ameyoUserId: secureLocalStorage.getItem("session_ameyoUserId"),
      ameyoApiUrl: secureLocalStorage.getItem("session_ameyoApiUrl"),
      ameyoHashKey: secureLocalStorage.getItem("session_ameyoHashKey"),
      ameyoCampaignId: secureLocalStorage.getItem("session_ameyoCampaignId"),
      ameyoIsActive: secureLocalStorage.getItem("session_ameyoIsActive"),
      bpsOnRoadEvent: "float-right text-eventTrigger",
      bpsOffRoadEvent: "float-right text-eventTrigger",
      bpsStartEvent: "float-right text-eventTrigger",
      bpsOnSceneEvent: "float-right text-eventTrigger",
      bpsOnBoardEvent: "float-right text-eventTrigger",
      bpsHosInEvent: "float-right text-eventTrigger",
      bpsHosOutEvent: "float-right text-eventTrigger",
      bpsClrEvent: "float-right text-eventTrigger",
      tripStatus: "",
      tripStatusTime: "",
      tripStatusTimeDuration: "",
      tripStatusBgColor: "#f5ffbd",
      fuelSensors: [],
      callingTypeDiv: false,
      gpsCommandList: [],
      gpsCommandId: 0,
      displayCommandDiv: "none",
      showCorpDashboard: parseBoolean(
        secureLocalStorage.getItem("session_ShowCorpDashboard")
      ),
    };
    this.closeInfo = this.closeInfo.bind(this);
    this.handleTrackVehicle = this.handleTrackVehicle.bind(this);
  }

  componentDidMount() {
    this.getVehicleIcon();
    this.getDriver();
  }

  handleExpDateChange = (date) => {
    this.setState({ expDate: date.value });
  };
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleImmobilizerToggle = async (e) => {
    e.preventDefault();
    let textMsg = "";

    const requestParams = getRequestParams("GET");
    const response = await fetch(
      getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
      "DeviceBackCommandRequests/GetcomndStatus/" +
      this.state.vehicleId,
      requestParams);

    const result = await response.json()
    const cmndTYpe = result.payload.Immobilizationstatus;
    const date1 = new Date(result.payload.ImmobilizationDate);
    const date2 = new Date();
    // date2.setMinutes(date1.getMinutes());
    const diffMs = date2 > date1 ? date2 - date1 : date1 - date1;
    const diffMinutes = (diffMs / (1000 * 60) * 60);

    console.log("command", diffMinutes)
    if (diffMinutes < 3 && (cmndTYpe === 2 || cmndTYpe === 3)) {
      Swal.fire(
        "Alert",
        `Command already sent. Please wait 3 minutes before resending.`,
        "warning"
      );
      return;
    }
    const isImmobilized =
      // this.state.vehicleDetails.immobilizationstatus == 3 ||
      // this.state.vehicleDetails.immobilizationstatus == 2
      //   ? false :
      true;

    // // // From: Vyshakh Sunil Kattungal <vkattungal@plexitech.com> 
    // // // Sent: Thursday, December 18, 2025 4:17 PM
    // // // To: mpatel@plexitech.com
    // // // Subject: Immobilizer Pop up message
    // // // Hi,
    // // // Vehicle engine is currently ON. Send Engine OFF command?
    // // // Replace with: Send Engine OFF command.
    // // // Command Already Sent waiting for Reply !!! Click resend want to Resend
    // // // Replace with : Command has already been sent and is awaiting a response. Click “Resend” to send the command again.
    // // // Thank you
    // // // Vyshakh Sunil

    let alertMessage =
      this.state.vehicleDetails.immobilizationstatus == 1 ||
        this.state.vehicleDetails.immobilizationstatus == 0
        ? "Send Engine OFF command"
        : this.state.vehicleDetails.immobilizationstatus == 2
          ? "Command sent to set immobilize. Waiting for acknowledgment."
          : this.state.vehicleDetails.immobilizationstatus == 3
            ? "Command sent to set Mobilize. Waiting for acknowledgment."
            : this.state.vehicleDetails.immobilizationstatus == 4
              ? "Send Engine On command"
              : " ";

    const CommandId =
      this.state.vehicleDetails.immobilizationstatus == 1 ||
        this.state.vehicleDetails.immobilizationstatus == 2 ||
        this.state.vehicleDetails.immobilizationstatus == 0
        ? 2
        : 3;

    Swal.fire({
      title: (cmndTYpe === 2 || cmndTYpe === 3) ? " " : alertMessage,
      text: (cmndTYpe === 2 || cmndTYpe === 3) ? "Command already sent. Waiting for a reply. Click ‘Resend’ to send again." : textMsg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: (cmndTYpe === 2 || cmndTYpe === 3) ? "#3085d6" : "Darkblue",
      cancelButtonColor: (cmndTYpe === 2 || cmndTYpe === 3) ? "Green" : "Red",
      confirmButtonText: (cmndTYpe === 2 || cmndTYpe === 3) ? "Resend" : "Yes",
      allowOutsideClick: false,
      // showConfirmButton: isImmobilized,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await new Promise((resolve) => setTimeout(resolve, 800));
        // update state — triggers re-render + color change
        this.setState((prevState) => ({
          vehicleDetails: {
            ...prevState.vehicleDetails,
            isImmobilized: 1,
            immobilizationstatus: CommandId,
          },
        }));
        Swal.fire("Updated!", "", "success");
        const requestParams = getRequestParams("POST");
        this.setState({ loadPanelVisible: true });
        let userId = secureLocalStorage.getItem("session_userId");
        const response = await fetch(
          getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "DeviceBackCommandRequests/SetimmobilizationMode/" +
          CommandId +
          "/" +
          this.state.vehicleId +
          "/" +
          userId,
          requestParams
        );
      }
    });
  };

  handleVehicleIconChange = (selectedOption) => {
    this.setState({
      vehicleIconId:
        selectedOption.selectedItem !== null
          ? selectedOption.selectedItem.id
          : 0,
      selVehicleIcon:
        selectedOption.selectedItem !== null
          ? selectedOption.selectedItem.iconName
          : "Set Icon",
    });
    if (selectedOption.selectedItem != null) {
      //this.state.errors["vehicleIcon"] = "";
    }
  };

  handleDriverChange = (selectedOption) => {
    this.setState({
      driverId:
        selectedOption.selectedItem !== null
          ? selectedOption.selectedItem.id
          : 0,
      selDriverName:
        selectedOption.selectedItem !== null
          ? selectedOption.selectedItem.name
          : "Change/Assign Driver",
    });
    if (selectedOption.selectedItem != null) {
      //this.state.errors["vehicleIcon"] = "";
    }
  };

  handleGpsCommandChange = (selectedOption) => {
    this.setState({
      gpsCommandId:
        selectedOption.selectedItem !== null
          ? selectedOption.selectedItem.commandID
          : 0,
    });
  };

  handleAddDriver = (e) => {
    e.preventDefault();
    this.setState({
      driverModalIsOpen: true,
      singelData: null,
      id: 0,
    });
  };

  getVehicleIcon = async () => {
    try {
      const requestParams = getRequestParams("GET");
      this.setState({
        loadPanelVisible: true,
      });
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + "VehicleIcon",
        requestParams
      );
      const data = await response.json();
      this.setState({
        dropdownVehicleIcon: data.payload != null ? data.payload : [],
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getVehicleIcon function",
        err
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  getDriver = async () => {
    try {
      const requestParams = getRequestParams("GET");
      this.setState({
        loadPanelVisible: true,
      });
      let accountId = secureLocalStorage.getItem("session_accountId");
      let locationId = secureLocalStorage.getItem("session_locationId");
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "Driver/dropdown/" +
        accountId +
        "/" +
        locationId,
        requestParams
      );
      const data = await response.json();
      this.setState({
        dropdownDriver: data.payload != null ? data.payload : [],
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log("Error in " + this.displayName + ".getDriver function", err);
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  closeInfo = async (e) => {
    if (e !== undefined && e.preventDefault !== undefined) {
      e.preventDefault();
    }
    this.setState({
      infoWindow: "none",
      vehicleId: 0,
      vehicleDetails: null,
      infoConfiguration: "none",
      infoVehicle: "none",
      overSpeedLimit: 0,
      dropdownVehicleIcon: [],
      dropdownDriver: [],
      isShowOverspeed: false,
      isShowVehicleIcon: false,
      isShowDriver: false,
      vehicleIconId: 0,
      driverId: 0,
      vehicleIcon: "Update",
      callingTypeDiv: false,
      currentDialingMobNo: null,
      isDialing1: false,
      isDialing2: false,
      gpsCommandList: [],
      gpsCommandId: 0,
      displayCommandDiv: "none",
    });
  };

  showInfo = (_vehicleDetails) => {
    debugger
    console.log(_vehicleDetails)
    try {
      window.gtag("event", "page_view", {
        page_title: "Vehicle Info",
        page_location: "/vehicle/info-window",
      });

      if (Object.keys(this.props).length != 0) {
        if (Object.keys(this.props)[0] != "openVehicle") {
          this.props.closeOtherWindows();
        }
      }
      excelDataValues = [];
      this.bindVehicleData(_vehicleDetails);
      if (_vehicleDetails.showButtonPanelTripEvents === true) {
        this.getVehicleButtonPanelStatus(_vehicleDetails.vehicleId);
      }
      this.fetchVehicleFuelSensors(_vehicleDetails.vehicleId);
      //this.downloadVehicleActivityDetails(_vehicleDetails.vehicleId);
      this.setState({
        infoWindow: "block",
        infoConfiguration: "none",
        infoVehicle: "block",
        currentDialingMobNo: null,
        isDialing1: false,
        isDialing2: false,
      });
    } catch (err) {
      console.log("Error in " + this.displayName + ".showInfo function", err);
    }
  };

  getVehicleId = () => {
    return this.state.vehicleId;
  };

  refresh = (_vehicleDetails) => {
    this.bindVehicleData(_vehicleDetails);
    if (_vehicleDetails.showButtonPanelTripEvents === true) {
      this.getVehicleButtonPanelStatus(_vehicleDetails.vehicleId);
    }
  };

  refreshWithTrip = (_vehicleDetails) => {
    this.bindVehicleData(_vehicleDetails);
    if (_vehicleDetails.showButtonPanelTripEvents === true) {
      this.getVehicleButtonPanelStatus(_vehicleDetails.vehicleId);
    }
  };

  bindVehicleData = (_vehicleDetails) => {
    var currentTime = moment(_vehicleDetails?.deviceDateTime);
    let batteryPercentageClass = "";
    if (
      _vehicleDetails.batteryPercentage >= 80 &&
      _vehicleDetails.batteryPercentage <= 200
    ) {
      batteryPercentageClass = "fas fa-battery-full";
    } else if (
      _vehicleDetails.batteryPercentage >= 60 &&
      _vehicleDetails.batteryPercentage <= 79
    ) {
      batteryPercentageClass = "fas fa-battery-three-quarters";
    } else if (
      _vehicleDetails.batteryPercentage >= 40 &&
      _vehicleDetails.batteryPercentage <= 59
    ) {
      batteryPercentageClass = "fas fa-battery-half";
    } else if (
      _vehicleDetails.batteryPercentage >= 10 &&
      _vehicleDetails.batteryPercentage <= 39
    ) {
      batteryPercentageClass = "fas fa-battery-quarter";
    } else {
      batteryPercentageClass = "fas fa-battery-empty";
    }

    let hostStatusTimeLabel = "";
    if (
      _vehicleDetails.hostStatusTime !== undefined &&
      _vehicleDetails.hostStatusTime !== null &&
      _vehicleDetails.hostStatusTime.length > 0
    ) {
      let sinceFor = _vehicleDetails.hostStatus === 1 ? "since" : "for";
      var newDateTime = moment(_vehicleDetails.hostStatusTime);
      var totalMinutes = 0;
      var totalSeconds = 0;
      totalMinutes = currentTime.diff(newDateTime, "minutes");
      totalSeconds = currentTime.diff(newDateTime, "seconds");

      // if(oldTripStatus != _vehicleDetails.tripStatus) {
      //     totalMinutes = 0;
      // }
      if (totalMinutes > 60 && totalMinutes < 1440) {
        var minutes = parseFloat((totalMinutes % 60).toFixed(0));
        var hours = ((totalMinutes - minutes) / 60).toFixed(0);
        hostStatusTimeLabel =
          sinceFor + " " + hours + " hrs " + minutes + " mins";
      } else if (totalMinutes > 1440) {
        var minutes = parseFloat((totalMinutes % 60).toFixed(0));
        var hours = ((totalMinutes - minutes) / 60).toFixed(0);
        var days = Math.floor(hours / 24);
        var hourss = hours % 24;
        hostStatusTimeLabel =
          sinceFor + " " + days + " days " + hourss + " hrs ";
      } else if (totalMinutes > 0) {
        hostStatusTimeLabel = sinceFor + " " + totalMinutes + " mins";
      } else if (totalMinutes === 0) {
        totalSeconds = currentTime.diff(newDateTime, "seconds");
        hostStatusTimeLabel = sinceFor + " " + totalSeconds + " secs";
      }
    }

    // if (_vehicleDetails.tripStatusTime !== undefined && _vehicleDetails.tripStatusTime !== null && _vehicleDetails.tripStatusTime.length > 0) {
    //     let oldTripStatus = _vehicleDetails.tripStatus;
    //     let sinceFor = _vehicleDetails.hostStatus === 1 ? "since" : "for";
    //     var newDateTime = moment(_vehicleDetails.tripStatusTime);
    //     var totalMinutes = 0;
    //     totalMinutes = currentTime.diff(newDateTime, 'minutes');
    //     if (totalMinutes > 60 && totalMinutes < 1440) {
    //         var minutes = parseFloat((totalMinutes % 60).toFixed(0));
    //         var hours = ((totalMinutes - minutes) / 60).toFixed(0);
    //         hostStatusTimeLabel = sinceFor + " " + hours + " hrs " + minutes + " mins";
    //     }
    //     else if (totalMinutes > 1440) {
    //         var minutes = parseFloat((totalMinutes % 60).toFixed(0));
    //         var hours = ((totalMinutes - minutes) / 60).toFixed(0);
    //         var days = Math.floor(hours / 24);
    //         var hourss = hours % 24;
    //         hostStatusTimeLabel = sinceFor + " " + days + " days " + hourss + " hrs ";
    //     }
    //     else if (totalMinutes > 0) {
    //         hostStatusTimeLabel = sinceFor + " " + totalMinutes + " mins";
    //     }
    // }

    let hostStatusClass = "badge badge-primary";
    let hostStatusTitleClass = "vehicle-title";

    if (this.state.showCorpDashboard) {
      if (
        (_vehicleDetails.tripStatus === "DISPATCHED" ||
          _vehicleDetails.tripStatus === "JOB CREATED") &&
        _vehicleDetails.status !== "Out Of Service"
      ) {
        hostStatusClass = "badge badge-success";
        hostStatusTitleClass = "vehicle-title-moving";
      } else if (
        (_vehicleDetails.tripStatus === "ON ROAD" ||
          _vehicleDetails.tripStatus === "") &&
        _vehicleDetails.status !== "Out Of Service"
      ) {
        hostStatusClass = "badge badge-warning";
        hostStatusTitleClass = "vehicle-title-idle";
      } else if (_vehicleDetails.tripStatus === "OFF ROAD") {
        hostStatusClass = "badge badge-danger";
        hostStatusTitleClass = "vehicle-title-stopped";
      } else if (
        _vehicleDetails.tripStatus !== "OFF ROAD" &&
        _vehicleDetails.status === "Out Of Service"
      ) {
        hostStatusClass = "badge badge-into";
        hostStatusTitleClass = "vehicle-title-noresponse";
      }
    } else {
      if (_vehicleDetails.hostStatus == 1) {
        hostStatusClass = "badge badge-success";
        hostStatusTitleClass = "vehicle-title-moving";
      } else if (_vehicleDetails.hostStatus == 2) {
        hostStatusClass = "badge badge-danger";
        hostStatusTitleClass = "vehicle-title-stopped";
      } else if (_vehicleDetails.hostStatus == 3) {
        hostStatusClass = "badge badge-warning";
        hostStatusTitleClass = "vehicle-title-idle";
      } else if (_vehicleDetails.hostStatus == 4) {
        hostStatusTitleClass = "vehicle-title-noresponse";
      }
    }

    let vehicleImage = "../assets/img/news/img08.jpg?v=1.0";
    if (_vehicleDetails.vehicleType !== null) {
      vehicleImage =
        "../assets/img/vehicleType/" +
        _vehicleDetails.vehicleType.replaceAll(" ", "") +
        ".jpg?v=1.0";
      if (_vehicleDetails.vehicleIcon == "AcTrainEngine") {
        vehicleImage = "../assets/img/vehicleType/AcLocalTrain.jpg?v=1.0";
      }
    }

    var tripStatusTime = "";
    var tripStatusTimeDuration = "";
    var tripStatusBgColor = "#f5ffbd";
    if (_vehicleDetails.tripStatus === "OFF ROAD") {
      tripStatusBgColor = "#fddcdc";
    }
    if (
      _vehicleDetails.tripStatusTime !== undefined &&
      _vehicleDetails.tripStatusTime !== null &&
      _vehicleDetails.tripStatusTime.length > 0
    ) {
      tripStatusTime = moment(_vehicleDetails.tripStatusTime).format("h:mm A");
      if (_vehicleDetails.showButtonPanelTripEvents === true) {
        tripStatusTimeDuration =
          formatTime(_vehicleDetails.tripStatusTime, "hh:mm:ss") +
          " (" +
          timeDiffCalc(_vehicleDetails.tripStatusTime, currentTime, "HM") +
          ")";
      } else {
        tripStatusTimeDuration = timeDiffCalc(
          _vehicleDetails.tripStatusTime,
          currentTime,
          "HM"
        );
      }
    }

    //console.log("ac1Status: " + _vehicleDetails.ac1Status);

    this.setState({
      vehicleId: _vehicleDetails.vehicleId,
      vehicleDetails: _vehicleDetails,
      vehicleIconId: _vehicleDetails.vehicleIconId,
      overSpeedLimit: _vehicleDetails.overSpeedLimit,
      vehicleIcon:
        _vehicleDetails.vehicleIcon.trim() === ""
          ? "Set Icon"
          : _vehicleDetails.vehicleIcon,
      vehicleDriverName:
        _vehicleDetails.driverName.trim() === ""
          ? "Assign Driver"
          : _vehicleDetails.driverName,
      vehicleImage: vehicleImage,
      batteryPercentageClass: batteryPercentageClass,
      hostStatusTimeLabel: hostStatusTimeLabel,
      hostStatusClass: hostStatusClass,
      hostStatusTitleClass: hostStatusTitleClass,
      driverMobileShowHide:
        (_vehicleDetails.driverMobileNo1 != null &&
          _vehicleDetails.driverMobileNo1.length > 0) ||
          (_vehicleDetails.driverMobileNo2 != null &&
            _vehicleDetails.driverMobileNo2.length > 0)
          ? true
          : false,
      tripStatusTime: tripStatusTime,
      tripStatusTimeDuration: tripStatusTimeDuration,
      tripStatusBgColor: tripStatusBgColor,
      tripStatus: _vehicleDetails.tripStatus,
    });
  };

  getVehicleButtonPanelStatus = (vehicleId) => {
    try {
      const requestParams = getRequestParams("GET");
      fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "VehicleLastStatusFetch/ButtonPanelStatus/" +
        vehicleId,
        requestParams
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((data) => {
          if (
            data === null ||
            data.payload === null ||
            data.payload === undefined
          )
            return;
          var currentTime = new Date();
          let buttonPanelStatus = {};

          let tripStatus = data.payload.tripStatus;
          let tripStatusTimeDuration =
            data.payload.tripStatusTime === null ||
              data.payload.tripStatusTime === ""
              ? ""
              : formatTime(data.payload.tripStatusTime, "hh:mm:ss") +
              " (" +
              timeDiffCalc(data.payload.tripStatusTime, currentTime, "HM") +
              ")";

          buttonPanelStatus.tripStatusTime =
            data.payload.tripStatusTime === null ||
              data.payload.tripStatusTime === ""
              ? ""
              : formatTime(data.payload.tripStatusTime, "hh:mm:ss") +
              " (" +
              timeDiffCalc(data.payload.tripStatusTime, currentTime, "HM") +
              ")";

          buttonPanelStatus.onRoadEventTime =
            data.payload.onRoadEventTime === null ||
              data.payload.onRoadEventTime === ""
              ? "OFF"
              : "ON " +
              moment(data.payload.onRoadEventTime).format("h:mm:ss A");
          buttonPanelStatus.onRoadEventTimeDur =
            data.payload.onRoadEventTime === null ||
              data.payload.onRoadEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(data.payload.onRoadEventTime, currentTime, "HM") +
              ")";

          buttonPanelStatus.offRoadEventTime =
            data.payload.offRoadEventTime === null ||
              data.payload.offRoadEventTime === ""
              ? "OFF"
              : "ON " +
              moment(data.payload.offRoadEventTime).format("h:mm:ss A");
          buttonPanelStatus.offRoadEventTimeDur =
            data.payload.offRoadEventTime === null ||
              data.payload.offRoadEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(data.payload.offRoadEventTime, currentTime, "HM") +
              ")";

          buttonPanelStatus.startTripEventTime =
            data.payload.startTripEventTime === null ||
              data.payload.startTripEventTime === ""
              ? "OFF"
              : "ON " +
              moment(data.payload.startTripEventTime).format("h:mm:ss A");
          buttonPanelStatus.startTripEventTimeDur =
            data.payload.startTripEventTime === null ||
              data.payload.startTripEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(
                data.payload.startTripEventTime,
                currentTime,
                "HM"
              ) +
              ")";

          buttonPanelStatus.onSceneEventTime =
            data.payload.onSceneEventTime === null ||
              data.payload.onSceneEventTime === ""
              ? "OFF"
              : "ON " +
              moment(data.payload.onSceneEventTime).format("h:mm:ss A");
          buttonPanelStatus.onSceneEventTimeDur =
            data.payload.onSceneEventTime === null ||
              data.payload.onSceneEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(data.payload.onSceneEventTime, currentTime, "HM") +
              ")";

          buttonPanelStatus.onBoardEventTime =
            data.payload.onBoardEventTime === null ||
              data.payload.onBoardEventTime === ""
              ? "OFF"
              : "ON " +
              moment(data.payload.onBoardEventTime).format("h:mm:ss A");
          buttonPanelStatus.onBoardEventTimeDur =
            data.payload.onBoardEventTime === null ||
              data.payload.onBoardEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(data.payload.onBoardEventTime, currentTime, "HM") +
              ")";

          buttonPanelStatus.hospitalInEventTime =
            data.payload.hospitalInEventTime === null ||
              data.payload.hospitalInEventTime === ""
              ? "OFF"
              : "ON " +
              moment(data.payload.hospitalInEventTime).format("h:mm:ss A");
          buttonPanelStatus.hospitalInEventTimeDur =
            data.payload.hospitalInEventTime === null ||
              data.payload.hospitalInEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(
                data.payload.hospitalInEventTime,
                currentTime,
                "HM"
              ) +
              ")";

          buttonPanelStatus.hospitalOutEventTime =
            data.payload.hospitalOutEventTime === null ||
              data.payload.hospitalOutEventTime === ""
              ? "OFF"
              : "ON " +
              moment(data.payload.hospitalOutEventTime).format("h:mm:ss A");
          buttonPanelStatus.hospitalOutEventTimeDur =
            data.payload.hospitalOutEventTime === null ||
              data.payload.hospitalOutEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(
                data.payload.hospitalOutEventTime,
                currentTime,
                "HM"
              ) +
              ")";

          buttonPanelStatus.clearEventTime =
            data.payload.clearEventTime === null ||
              data.payload.clearEventTime === ""
              ? "OFF"
              : "ON " + moment(data.payload.clearEventTime).format("h:mm:ss A");
          buttonPanelStatus.clearEventTimeDur =
            data.payload.clearEventTime === null ||
              data.payload.clearEventTime === ""
              ? ""
              : "(" +
              timeDiffCalc(data.payload.clearEventTime, currentTime, "HM") +
              ")";

          let bpsOnRoadEvent =
            buttonPanelStatus.onRoadEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";
          let bpsOffRoadEvent =
            buttonPanelStatus.offRoadEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";
          let bpsStartEvent =
            buttonPanelStatus.startTripEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";
          let bpsOnSceneEvent =
            buttonPanelStatus.onSceneEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";
          let bpsOnBoardEvent =
            buttonPanelStatus.onBoardEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";
          let bpsHosInEvent =
            buttonPanelStatus.hospitalInEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";
          let bpsHosOutEvent =
            buttonPanelStatus.hospitalOutEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";
          let bpsClrEvent =
            buttonPanelStatus.clearEventTime.trim() != "OFF"
              ? "float-right text-eventTrigger"
              : "float-right text-eventNotTrigger";

          this.setState({
            vehicleButtonPanelStatus: buttonPanelStatus,
            bpsOnRoadEvent: bpsOnRoadEvent,
            bpsOffRoadEvent: bpsOffRoadEvent,
            bpsStartEvent: bpsStartEvent,
            bpsOnSceneEvent: bpsOnSceneEvent,
            bpsOnBoardEvent: bpsOnBoardEvent,
            bpsHosInEvent: bpsHosInEvent,
            bpsHosOutEvent: bpsHosOutEvent,
            bpsClrEvent: bpsClrEvent,
            tripStatus: tripStatus,
            tripStatusTimeDuration: tripStatusTimeDuration,
          });
        });
    } catch (err) {
      console.log(
        "Error in " +
        this.displayName +
        ".getVehicleButtonPanelStatus function",
        err
      );
    }
  };

  fetchVehicleFuelSensors = (vehicleId) => {
    try {
      let fuelSensors = localStorage.getItem("fuelSensors_" + vehicleId);
      if (fuelSensors !== null && fuelSensors !== undefined) {
        this.setState({
          fuelSensors: JSON.parse(fuelSensors),
        });
        return;
      }
      const requestParams = getRequestParams("GET");
      fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "VehicleSensor/GetFuelSensors/" +
        vehicleId +
        "/false",
        requestParams
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((data) => {
          if (
            data === null ||
            data.payload === null ||
            data.payload === undefined
          ) {
            this.setState({ fuelSensors: [] });
          } else {
            this.setState({ fuelSensors: data.payload });
            localStorage.setItem(
              "fuelSensors_" + vehicleId,
              JSON.stringify(data.payload)
            );
          }
        });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".fetchVehicleFuelSensors function",
        err
      );
    }
  };

  showVehicleOverspeed = async (e) => {
    e.preventDefault();
    if (this.state.isShowOverspeed === true) {
      this.setState({ isShowOverspeed: false });
    } else {
      this.setState({ isShowOverspeed: true });
    }
  };

  showVehicleIcon = async (e) => {
    e.preventDefault();
    if (this.state.isShowVehicleIcon === true) {
      this.setState({ isShowVehicleIcon: false });
    } else {
      this.setState({ isShowVehicleIcon: true });
    }
  };

  showDriver = async (e) => {
    e.preventDefault();
    const requestParams = getRequestParams("GET");
    this.setState({
      loadPanelVisible: true,
    });
    let accountId = secureLocalStorage.getItem("session_accountId");
    let locationId = secureLocalStorage.getItem("session_locationId");
    this.setState({ dropdownDriver: [] });
    const response = await fetch(
      getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
      "Driver/dropdown/" +
      accountId +
      "/" +
      locationId,
      requestParams
    );
    const data = await response.json();
    this.setState({
      dropdownDriver: data.payload != null ? data.payload : [],
      loadPanelVisible: false,
    });

    if (this.state.isShowDriver === true) {
      this.setState({ isShowDriver: false });
    } else {
      this.setState({ isShowDriver: true });
    }
  };

  showInfoConfiguration = async (e) => {
    e.preventDefault();
    this.setState({ infoConfiguration: "block", infoVehicle: "none" });
  };

  showInfoVehicle = async (e) => {
    e.preventDefault();
    this.setState({ infoConfiguration: "none", infoVehicle: "block" });
  };

  showGpsCommandDiv = async (e) => {
    e.preventDefault();
    if (this.state.displayCommandDiv == "none") {
      try {
        const requestParams = getRequestParams("GET");
        this.setState({ loadPanelVisible: true });
        let userId = secureLocalStorage.getItem("session_userId");
        const response = await fetch(
          getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "DeviceBackCommandRequests/GetCommandList/" +
          this.state.vehicleId +
          "/" +
          userId,
          requestParams
        );
        const data = await response.json();
        this.setState({
          gpsCommandList: data.payload != null ? data.payload : [],
        });
      } catch (err) {
        console.log(
          "Error in " + this.displayName + ".showGpsCommandDiv function",
          err
        );
        this.setState({
          loadPanelVisible: false,
        });
      }
      this.setState({ displayCommandDiv: "block" });
    } else {
      this.setState({
        displayCommandDiv: "none",
        gpsCommandList: [],
        gpsCommandId: 0,
      });
    }
  };

  setDeviceGpsCommandType = async () => {
    debugger;
    if (this.state.gpsCommandId == 0) {
      toast.error("Please select command.", {
        //position: toast. POSITION.BOTTOM _CENTER,
        position: 'bottom-center',
        autoClose: 5000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        //closeButton : false
      });
      return false;
    }

    try {
      const requestParams = getRequestParams("GET");
      this.setState({ loadPanelVisible: true });
      let userId = secureLocalStorage.getItem("session_userId");
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "DeviceBackCommandRequests/SetGpsCommand/" +
        this.state.gpsCommandId +
        "/" +
        this.state.vehicleId +
        "/" +
        userId,
        requestParams
      );
      this.setState({ loadPanelVisible: false });
      const data = await response.json();

      if (data != null) {
        if (data.isSuccess) {
          
          toast.success(data.message, {
            //position: toast. POSITION.BOTTOM _CENTER,
            position: 'bottom-center',
            autoClose: 5000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            //closeButton : false
          });
          this.setState({
            displayCommandDiv: "none",
            gpsCommandList: [],
            gpsCommandId: 0,
          });
        } else {
          toast.error(data.message, {
            //position: toast. POSITION.BOTTOM _CENTER,
            position: 'bottom-center',
            autoClose: 5000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            //closeButton : false
          });
        }
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".setDeviceGpsCommandType function",
        err
      );
      this.setState({ loadPanelVisible: false });
    }
  };

  updateOverspeed = async (e) => {
    e.preventDefault();
    try {
      let vehicles = [];
      vehicles.push(this.state.vehicleDetails.vehicleId);

      let request = new Object();
      request.AccountId = secureLocalStorage.getItem("session_accountId");
      request.LocationId = secureLocalStorage.getItem("session_locationId");
      request.UserId = secureLocalStorage.getItem("session_userId");
      request.OverSpeedLimit = Number(this.state.overSpeedLimit);
      request.VehicleId = vehicles;
      const requestParams = getRequestParams("POST", request);
      this.setState({
        loadPanelVisible: true,
      });
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "Vehicles/OverSpeedLimit",
        requestParams
      );
      const data = await response.json();

      if (data.isSuccess) {
        let newVehicleDetails = this.state.vehicleDetails;
        newVehicleDetails.overSpeedLimit = this.state.overSpeedLimit;
        this.setState({
          overSpeedLimit: this.state.overSpeedLimit,
          isShowOverspeed: false,
        });
        toast.success(
          "Overspeed for vehicle [" +
          this.state.vehicleDetails.vehicleNo +
          "] updated succesfully.",
          {
            //position: toast. POSITION.BOTTOM _CENTER,
            position: 'bottom-center',
            autoClose: 5000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            //closeButton : false
          }
        );
        //toast("Overspeed for vehicle [" + this.state.vehicleDetails.vehicleNo + "] updated succesfully.");
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".updateOverspeed function",
        err
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  updateVehicleIcon = async (e) => {
    e.preventDefault();
    try {
      const requestParams = getRequestParams("GET");
      this.setState({
        loadPanelVisible: true,
      });
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "VehicleIcon/UpdateVehicleIcon/" +
        this.state.vehicleDetails.vehicleId +
        "/" +
        this.state.vehicleIconId,
        requestParams
      );
      const data = await response.json();

      if (data.isSuccess) {
        let newVehicleDetails = this.state.vehicleDetails;
        newVehicleDetails.vehicleIconId = this.state.vehicleIconId;
        newVehicleDetails.vehicleIcon = this.state.selVehicleIcon;
        this.setState({
          vehicleIconId: this.state.vehicleIconId,
          isShowVehicleIcon: false,
          vehicleIcon: this.state.selVehicleIcon,
        });
        toast.success(
          "Icon for vehicle [" +
          this.state.vehicleDetails.vehicleNo.trim() +
          "] updated succesfully.",
          {
            //position: toast. POSITION.BOTTOM _CENTER,
            position: 'bottom-center',
            autoClose: 5000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            //closeButton : false
          }
        );
        //toast("Icon for vehicle [" + this.state.vehicleDetails.vehicleNo + "] updated succesfully.");
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".updateVehicleIcon function",
        err
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  unassignDriver = async (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Do you want to Unassign Driver ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      allowOutsideClick: false,
      showConfirmButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const requestParams = getRequestParams("PUT");
        const response = await fetch(
          getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "Driver/unassigndriver/" +
          this.state.vehicleDetails.vehicleId +
          "/" +
          this.state.driverId,
          requestParams
        );
        const data = await response.json();
        if (data.isSuccess) {
          this.setState({ vehicleDriverName: "Assign Driver" });
          toast.success("Driver unassigned succesfully.", {
            //position: toast. POSITION.BOTTOM _CENTER,
            position: 'bottom-center',
            autoClose: 5000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
          });
        } else {
          toast.info("unable to unassigne Driver", {
            //position: toast. POSITION.BOTTOM _CENTER,
            position: 'bottom-center',
            autoClose: 5000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
          });
        }
      }
    });
  };

  assignDriver = async (e) => {
    e.preventDefault();
    try {
      const requestParams = getRequestParams("PUT");
      this.setState({
        loadPanelVisible: true,
      });

      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "Driver/assigndriver/" +
        this.state.vehicleDetails.vehicleId +
        "/" +
        this.state.driverId,
        requestParams
      );
      const data = await response.json();
      if (data.isSuccess) {
        let newVehicleDetails = this.state.vehicleDetails;
        newVehicleDetails.driverId = this.state.driverId;
        newVehicleDetails.vehicleDriverName = this.state.selDriverName;
        this.setState({
          driverId: this.state.driverId,
          isShowDriver: false,
          vehicleDriverName: this.state.selDriverName,
        });
        toast.success(
          "Driver [" +
          this.state.selDriverName.trim() +
          "] assigned succesfully.",
          {
            //position: toast. POSITION.BOTTOM _CENTER,
            position: 'bottom-center',
            autoClose: 5000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
          }
        );
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".assignDriver function",
        err
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  isFormValid = () => {
    let formIsValid = true;
    try {
      let errors = this.state.errors;
      errors.driverName = "";
      errors.driverLName = "";
      errors.licenceNumber = "";
      errors.mobileNumber1 = "";
      errors.mobileNumber2 = "";
      errors.email = "";
      errors.dState = "";
      errors.city = "";
      errors.expDate = "";
      errors.address = "";
      errors.driverKey = "";
      if (this.state.driverName.trim() === "") {
        formIsValid = false;
        errors.driverName = "Please enter Driver First Name.";
      }
      if (this.state.driverLName.trim() === "") {
        formIsValid = false;
        errors.driverLName = "Please enter Driver Last Name.";
      }

      if (this.state.licenceNumber.trim() === "") {
        formIsValid = false;
        errors.licenceNumber = "Please enter Licence Number.";
      }
      if (this.state.expDate == "") {
        formIsValid = false;
        errors.expDate = "Please select Date";
      }
      // if (
      //   this.state.mobileNumber1 == null ||
      //   this.state.mobileNumber1.trim() == ""  ||
      //   this.state.mobileNumber1.trim().length < 10

      // ) {
      //   formIsValid = false;
      //   errors.mobileNumber1 = "Please enter Mobile Number.";
      // }
      if (
        this.state.mobileNumber2 == null ||
        this.state.mobileNumber2.trim() == "" ||
        this.state.mobileNumber2.trim().length < 10
      ) {
        formIsValid = false;
        errors.mobileNumber2 = "Please enter Mobile Number.";
      }
      // if (this.state.email.trim() === "") {
      //   formIsValid = false;
      //   errors.email = "Please enter Email.";
      // }
      if (this.state.dState.trim() === "") {
        formIsValid = false;
        errors.dState = "Please enter State.";
      }
      if (this.state.city.trim() === "") {
        formIsValid = false;
        errors.city = "Please enter City.";
      }
      if (this.state.address.trim() === "") {
        formIsValid = false;
        errors.address = "Please enter Address.";
      }

      // if (this.state.driverKey.trim() === "") {
      //   formIsValid = false;
      //   errors.driverKey = "Please enter DriverKey.";
      // }
      this.setState({ errors: errors });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".isFormValid function",
        err
      );
      formIsValid = false;
    }
    return formIsValid;
  };

  handleDriverSubmit = async (e) => {
    e.preventDefault();
    try {
      var request = new Object();
      const requestParams = getRequestParams("GET", request);

      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        `Driver/checkDriverNameExist/${this.state.driverName}/${this.state.driverLName}`,
        requestParams
      );
      var data = await response.json();
      let errors = this.state.errors;
      this.setState({ errors: errors });
      let formIsValid = true;
      console.log("AA", data);
      if (data.payload > 0) {
        errors.driverName = "Already Exists First Name.";
        errors.driverLName = "Already Exists Last Name.";
        //    isFormValid = false;

        formIsValid = false;
        this.setState({ errors: errors });
        return;
      }

      if (this.isFormValid()) {
        this.setState({ isSubmited: true });
        var request = new Object();
        request.Id = this.state.id;
        request.AccountId = Number(
          secureLocalStorage.getItem("session_accountId")
        );
        request.LocationId = Number(
          secureLocalStorage.getItem("session_locationId")
        );
        request.UserId = Number(secureLocalStorage.getItem("session_userId"));
        request.FirstName = this.state.driverName;
        request.LastName = this.state.driverLName;
        // request.MobileNo = this.state.mobileNumber1;
        request.MobileNo = this.state.mobileNumber2;
        request.Email = this.state.email;
        request.DriverLicenseNumber = this.state.licenceNumber;
        request.CityName = this.state.city;
        request.StateName = this.state.dState;
        request.Address = this.state.address;
        request.isActive = this.state.isActive;
        request.Enable = this.state.isActive;
        request.DriverKey = this.state.driverKey;
        request.DriverLicenseExpiryDate =
          this.state.expDate != "" ? this.state.expDate : "";
        var DriverSubmit = null;
        if (request.Id == 0) {
          DriverSubmit = "POST";
        } else {
          DriverSubmit = "PUT";
        }
        const requestParams = getRequestParams(DriverSubmit, request);
        const response = await fetch(
          getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + "Driver",
          requestParams
        );
        const data = await response.json();
        if (data.isSuccess) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
          }).then((result) => {
            if (result.isConfirmed) {
              this.handleResetStateData();
            }
            this.setState({
              isSubmited: false,
              driverModalIsOpen: false,
            });
          });
        } else {
          toast(data.message);
          this.setState({ isSubmited: false });
        }
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleDriverSubmit function",
        err
      );
    }
  };

  handleResetStateData = async () => {
    this.setState({
      isSubmited: false,
      loadPanelVisible: false,
      driverModalIsOpen: false,
      driverData: null,
      licenceNumber: "",
      driverName: "",
      driverLName: "",
      mobileNumber1: "",
      mobileNumber2: "",
      email: "",
      city: "",
      dState: "",
      address: "",
      driverKey: "",
      expDate: "",
      errors: {
        licenceNumber: "",
        driverName: "",
        driverLName: "",
        mobileNumber1: "",
        mobileNumber2: "",
        email: "",
        city: "",
        dState: "",
        address: "",
        driverKey: "",
        expDate: "",
      },
    });
  };

  // getVehicleActivity = async(e) =>{
  //     e.preventDefault();
  //     await this.downloadVehicleActivityDetails();
  // }

  // downloadVehicleActivityDetails = async (vehicleId) => {
  //     try {
  //         //let vehicleId = this.state.vehicleId;
  //         let vehicleIdList = [];
  //         vehicleIdList.push(vehicleId);
  //         let accountId = parseInt(secureLocalStorage.getItem('session_accountId'));
  //         let locationId = parseInt(secureLocalStorage.getItem('session_locationId'));
  //         let userId = parseInt(secureLocalStorage.getItem('session_userId'));
  //         let industryId = parseInt(secureLocalStorage.getItem('session_industryTypeId'));

  //         let request = new Object();
  //         request.UserId = userId;
  //         request.AccountId = accountId;
  //         request.LocationId = locationId;
  //         request.GridName = "Activity";
  //         request.IndustryId = industryId;
  //         request.IsFixed = false;
  //         request.VehicleId = vehicleIdList;
  //         request.VehicleGroupId = 0;
  //         request.ReportType = 1;
  //         request.ReportTypeId = [];
  //         request.DateFrom = formatDate(this.state.startTime, "MM/dd/yyyy hh:mm");
  //         request.DateTo = formatDate(this.state.endTime, "MM/dd/yyyy hh:mm");
  //         request.MinimumKilometer = 0;
  //         request.MinimumStoppageDuration = 0;
  //         request.PoiId = [];
  //         request.ProjectId = 0;
  //         request.DistrictId = 0;
  //         request.PlantLocationId = 0;
  //         request.TripId = 0;
  //         request.JobNo = "";
  //         request.SubReport = "";
  //         this.setState()
  //         const requestParams = getRequestParams('POST', request);
  //         fetch(getBaseApiUrl(process.env.REACT_APP_REPORT_API_BASE_URL) + "Tracking/Activity", requestParams)
  //             .then(response => { if (response.ok) { return response.json() } })
  //             .then(data => {
  //                 if (data != null) {

  //                     // excelDataValues = data.payload.dataValues;
  //                     // this.setState({
  //                     //     downloadDataSet: data.payload,
  //                     //     downloadDataFields: data.payload.dataFields,
  //                     //     downloadDataValues: data.payload.dataValues
  //                     // });
  //                 }
  //             })

  //         // const requestParams = getRequestParams('POST', request);
  //         // const response = await fetch(getBaseApiUrl(process.env.REACT_APP_REPORT_API_BASE_URL) + "Tracking/Activity", requestParams);
  //         // const data = await response.json();
  //         // excelDataValues = data.payload.dataValues;
  //         // this.setState({
  //         //     downloadDataSet: data.payload,
  //         //     downloadDataFields: data.payload.dataFields,
  //         //     downloadDataValues: data.payload.dataValues
  //         // }, () => {
  //         //     //console.log(this.state.boardAddModalShow)
  //         // });
  //     } catch (err) {
  //         console.log("Error in " + this.displayName + ".exportToExcel function", err);
  //     }
  // }

  downloadVehicleActivityDetails = async (vehicleId) => {
    let exportFileName =
      "Activity_" +
      moment(this.state.startTime).format("DD-MM") +
      "_" +
      moment(this.state.endTime).endOf("day").format("DD-MM") +
      "_" +
      this.state.vehicleDetails.vehicleNo.replace(" ", "");

    const workbook = new Excel.Workbook();
    const workSheetName = "Worksheet-1";
    const workBookName = "MyWorkBook";
    try {
      //let vehicleId = this.state.vehicleId;
      let vehicleIdList = [];
      vehicleIdList.push(vehicleId);
      let accountId = parseInt(secureLocalStorage.getItem("session_accountId"));
      let locationId = parseInt(
        secureLocalStorage.getItem("session_locationId")
      );
      let userId = parseInt(secureLocalStorage.getItem("session_userId"));
      let industryId = parseInt(
        secureLocalStorage.getItem("session_industryTypeId")
      );

      let request = new Object();
      request.UserId = userId;
      request.AccountId = accountId;
      request.LocationId = locationId;
      request.GridName = "Activity";
      request.IndustryId = industryId;
      request.IsFixed = false;
      request.VehicleId = vehicleIdList;
      request.VehicleGroupId = 0;
      request.ReportType = 1;
      request.ReportTypeId = [];
      request.DateFrom = formatDate(this.state.startTime, "MM/dd/yyyy hh:mm");
      request.DateTo = formatDate(this.state.endTime, "MM/dd/yyyy hh:mm");
      request.MinimumKilometer = 0;
      request.MinimumStoppageDuration = 0;
      request.PoiId = [];
      request.ProjectId = 0;
      request.DistrictId = 0;
      request.PlantLocationId = 0;
      request.TripId = 0;
      request.JobNo = "";
      request.SubReport = "";
      this.setState({ isSubmited: true });
      const requestParams = getRequestParams("POST", request);
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_REPORT_API_BASE_URL) +
        "Tracking/Activity",
        requestParams
      );
      const data = await response.json();
      this.setState({ isSubmited: false });
      if (data != null) {
        //#region  Export
        const fileName = exportFileName;

        // creating one worksheet in workbook
        const worksheet = workbook.addWorksheet("Data");

        // add worksheet columns
        // each columns contains header and its mapping key from data
        const columns = [
          { header: "Fleet location", key: "baseLocation" },
          { header: "Transporter", key: "transporter" },
          { header: "Vehicle #", key: "vehicleNo" },
          { header: "Date", key: "dateTime" },
          { header: "Status", key: "status" },
          { header: "Event", key: "event" },
          { header: "Speed", key: "speed" },
          { header: "Odometer", key: "odometer" },
          { header: "FuelLevel", key: "fuelLevel" },
          { header: "Place", key: "address" },
          { header: "Battery%", key: "batteryPercentage" },
          { header: "Ignition", key: "ignition" },
        ];

        worksheet.columns = columns; // data.payload.dataFields;

        // updated the font for first row.
        worksheet.getRow(1).font = { bold: true };

        //loop through all of the columns and set the alignment with width.
        worksheet.columns.forEach((column) => {
          column.width = column.header.length + 5;
          column.alignment = { horizontal: "center" };
        });

        // loop through data and add each one to worksheet
        data.payload.dataValues.forEach((singleData) => {
          worksheet.addRow(singleData);
        });

        // loop through all of the rows and set the outline style.
        worksheet.eachRow({ includeEmpty: false }, (row) => {
          // store each cell to currentCell
          const currentCell = row._cells;

          // loop through currentCell to apply border only for the non-empty cell of excel
          currentCell.forEach((singleCell) => {
            // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
            const cellAddress = singleCell._address;

            // apply border
            worksheet.getCell(cellAddress).border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });

        // write the content using writeBuffer
        const buf = await workbook.xlsx.writeBuffer();

        // download the processed file
        saveAs(new Blob([buf]), `${fileName}.xlsx`);
        //#endregion
      }
    } catch (err) {
      console.log(
        "Error in " +
        this.displayName +
        ".downloadVehicleActivityDetails function",
        err
      );
      this.setState({ isSubmited: false });
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
      this.setState({ isSubmited: false });
    }
  };

  handleTrackVehicle = () => {
    if (this.state.vehicleId != 0) {
      if (Object.keys(this.props).length != 0) {
        if (Object.keys(this.props)[0] != "openVehicle") {
          let vehicle = this.state.vehicleDetails;
          this.props.handleTrackVehicle(
            this.state.vehicleId,
            vehicle.vehicleNo,
            vehicle.latitude,
            vehicle.longitude
          );
        } else {
          this.props.openVehicle();
        }
      }
    }
  };

  handleClickOnMobileNo1 = (mobNo) => {
    this.setState({
      callingTypeDiv: true,
      currentDialingMobNo: mobNo,
      Number1Dialed: mobNo,
      Number2Dialed: "",
    });
  };

  handleClickOnMobileNo2 = (mobNo) => {
    this.setState({
      callingTypeDiv: true,
      currentDialingMobNo: mobNo,
      Number1Dialed: "",
      Number2Dialed: mobNo,
    });
  };

  handleDialer = async (e) => {
    // if (this.state.currentDialingMobNo == mobNo) {
    //     return false;
    // }
    var mobNo = this.state.currentDialingMobNo;
    if (this.state.Number1Dialed === mobNo) {
      this.setState({ isDialing1: true, isDialing2: false });
    }
    if (this.state.Number2Dialed === mobNo) {
      this.setState({ isDialing1: false, isDialing2: true });
    }
    if (mobNo.charAt(0) != "0") {
      var zero = "0";
      mobNo = zero.concat(mobNo);
    }
    try {
      var dataObj = {};
      dataObj.UserId = this.state.ameyoUserId;
      dataObj.CampaignId = this.state.ameyoCampaignId;
      dataObj.Phone = mobNo;
      //dataObj.RequestId = ((new Date()).getTime() / 1000).toFixed()
      dataObj.ShouldAddCustomer = "false";
      //dataObj.AdditionalParams = new Object();
      dataObj.AmeyoApiUrl = this.state.ameyoApiUrl;
      dataObj.AmeyoHashKey = this.state.ameyoHashKey;

      const requestParams = getRequestParams("POST", dataObj);
      await fetch(
        getBaseApiUrl(process.env.REACT_APP_UTWIZ_PROXY_API_URL) +
        "ZhlProxyApi/zhl/dialer",
        requestParams
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            this.setState({
              currentDialingMobNo: null,
              isDialing1: false,
              isDialing2: false,
              callingTypeDiv: false,
            });
          }
        })
        .then((data) => {
          this.setState({
            currentDialingMobNo: null,
            isDialing1: false,
            isDialing2: false,
            callingTypeDiv: false,
          });
          if (data != null) {
            var alertType = data.status != "error" ? "success" : "warning";
            var message =
              data.status != "error" ? "Dialed successfully" : data.reason;
            var timeout = data.status != "error" ? 2 : 5;
            Swal.fire({
              html: message,
              icon: alertType,
              allowOutsideClick: false,
            });
          } else {
            Swal.fire({
              html: "Failed to call dialer..",
              icon: "warning",
              allowOutsideClick: false,
            });
          }
        });

      // const requestParams = {
      //     method: 'POST',
      //     "headers": {
      //         "hash-key": this.state.ameyoHashKey,
      //         "Content-Type": "application/x-www-form-urlencoded",
      //         "policy-name": "token-based-authorization-policy",
      //         "requesting-host": "local-click-to-call",
      //         // "Access-Control-Allow-Origin":"*",
      //         // "Access-Control-Allow-Credentials":"true",
      //         // "Access-Control-Allow-Methods":"GET,HEAD,OPTIONS,POST,PUT",
      //         // "Access-Control-Allow-Headers":"Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      //     },
      // }

      // fetch(this.state.ameyoApiUrl + JSON.stringify(dataObj), requestParams)
      //     .then(response => {
      //         if (response.ok) {
      //             return response.json()
      //         }
      //         else {
      //             this.setState({ currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
      //         }
      //     })
      //     .then(data => {
      //         this.setState({ currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
      //         if (data != null) {
      //             var alertType = data.status != "error" ? "success" : "warning";
      //             var message = data.status != "error" ? "Dialed successfully" : data.reason;
      //             var timeout = data.status != "error" ? 2 : 5;
      //             Swal.fire({
      //                 html: message,
      //                 icon: alertType,
      //                 allowOutsideClick: false
      //             });
      //         }
      //         else {
      //             Swal.fire({
      //                 html: "Failed to call dialer..",
      //                 icon: "warning",
      //                 allowOutsideClick: false
      //             });
      //         }
      //     });
    } catch (err) {
      this.setState({
        currentDialingMobNo: null,
        isDialing1: false,
        isDialing2: false,
        callingTypeDiv: false,
      });
      Swal.fire({
        html: "Failed to call dialer.",
        icon: "warning",
        allowOutsideClick: false,
      });
      console.log(
        "Error in " + this.displayName + ".handleDialer function",
        err
      );
    }

    // var settings = {
    //     "url": this.state.ameyoApiUrl + JSON.stringify(dataObj),
    //     "method": "POST",
    //     "timeout": 0,
    //     "headers": {
    //         "hash-key": this.state.ameyoHashKey,
    //         "Content-Type": "application/x-www-form-urlencoded",
    //         "policy-name": "token-based-authorization-policy",
    //         "requesting-host": "local-click-to-call"
    //     },
    //     "processData": false,
    //     "mimeType": "multipart/form-data",
    //     "contentType": false,
    //     "data": form,
    //     success: function (result, status, xhr) {
    //         this.setState({ currentDialingMobNo : null, isDialing1 : false});
    //         if (status == "success") {
    //             var response = JSON.parse(result);
    //             if (response != null) {
    //                 var alertType = response.status != "error" ? "success" : "danger";
    //                 var message = response.status != "error" ? "Dialed successfully" : response.reason;
    //                 var timeout = response.status != "error" ? 2 : 5;
    //                 Swal.fire({
    //                     html: message,
    //                     icon: alertType,
    //                     // showCancelButton: true,
    //                     // confirmButtonColor: '#3085d6',
    //                     // cancelButtonColor: '#d33',
    //                     // confirmButtonText: 'Yes',
    //                     allowOutsideClick: false
    //                 });
    //             }
    //         } else {
    //             Swal.fire({
    //                 html: "Failed to call dialer..",
    //                 icon: "danger",
    //                 allowOutsideClick: false
    //             });
    //         }
    //     },
    //     error: function (xhr) {
    //         this.setState({ currentDialingMobNo : null, isDialing1 : false});
    //         Swal.fire({
    //             html: "Failed to call dialer.",
    //             icon: "danger",
    //             allowOutsideClick: false
    //         });
    //     }
    // };
    // $.ajax(settings);
  };

  handleConfigDialer = async () => {
    var mobNo = this.state.currentDialingMobNo;
    this.setState({ isDialing1: true });
    if (mobNo.charAt(0) != "0") {
      var zero = "0";
      mobNo = zero.concat(mobNo);
    }

    try {
      this.setState({ loadPanelVisible: true });
      const requestParams = getRequestParams("GET");
      var userName = secureLocalStorage.getItem("session_userName");

      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
        "AmeyoDialer/ConCallSession/" +
        userName,
        requestParams
      );
      const data = await response.json();

      if (data.isSuccess) {
        var dataObj = {};
        dataObj.UserName = userName;
        dataObj.PhoneNo = mobNo;
        dataObj.DialerSettings = {};
        dataObj.DialerSettings.Id = data.payload.id;
        dataObj.DialerSettings.UserName = userName;
        dataObj.DialerSettings.AmeyoUserId = data.payload.ameyoUserId;
        dataObj.DialerSettings.AmeyoApiUrl = data.payload.ameyoApiUrl;
        dataObj.DialerSettings.HashKey = data.payload.hashKey;
        dataObj.DialerSettings.CampaignId = data.payload.campaignId;
        dataObj.DialerSettings.IsActive = data.payload.isActive;
        dataObj.DialerSettings.CreatedOn = data.payload.createdOn;
        dataObj.DialerSettings.AmeyoConferCallApiUrl =
          data.payload.ameyoConferCallApiUrl;
        dataObj.DialerSettings.ConCallInitTime = data.payload.conCallInitTime;
        dataObj.DialerSettings.ConCallSessionId = data.payload.conCallSessionId;
        dataObj.DialerSettings.ConCallUserCrtObjectId =
          data.payload.conCallUserCrtObjectId;
        dataObj.DialerSettings.ConCallCrtObjectId =
          data.payload.conCallCrtObjectId;
        dataObj.DialerSettings.ConCallCampaignId =
          data.payload.conCallCampaignId;
        dataObj.DialerSettings.ConCallPhoneNo = data.payload.conCallPhoneNo;

        const requestParams = getRequestParams("POST", dataObj);
        await fetch(
          getBaseApiUrl(process.env.REACT_APP_UTWIZ_PROXY_API_URL) +
          "ZhlProxyApi/zhl/initconcall",
          requestParams
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              this.setState({
                currentDialingMobNo: null,
                isDialing1: false,
                isDialing2: false,
                callingTypeDiv: false,
              });
            }
          })
          .then((data) => {
            this.setState({
              currentDialingMobNo: null,
              isDialing1: false,
              isDialing2: false,
              callingTypeDiv: false,
            });
            if (data != null) {
              var alertType = data.status === 200 ? "success" : "error";
              var message =
                data.status === 200
                  ? "conference call added successfully"
                  : data.message;
              var timeout = data.status === 200 ? 2 : 5;
              Swal.fire({
                html: message,
                icon: alertType,
                allowOutsideClick: false,
              });
            } else {
              Swal.fire({
                html: "Failed to add conference call..",
                icon: "warning",
                allowOutsideClick: false,
              });
            }
          });
      } else {
        Swal.fire({
          html: data.message,
          icon: data.isSuccess,
          allowOutsideClick: false,
        });
      } /*"Access-Control-Allow-Origin": "*"*/ /*

//       // fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'AmeyoDialer/ConCallSession/' + userName, requestParams)
//       //     .then(response => {
//       //         if (response.ok) {
//       //             return response.json()
//       //         }
//       //         else {
//       //             console.log(response);
//       //             this.setState({ loadPanelVisible: false, currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
//       //         }
//       //     })
//       //     .then(data => {

//       //     });

//       // fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'AmeyoDialer/InitConCall/' + userName + "/" + mobNo, requestParams)
//       //     .then(response => {
//       //         if (response.ok) {
//       //             return response.json()
//       //         }
//       //         else {
//       //             console.log(response);
//       //             this.setState({ loadPanelVisible: false, currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
//       //         }
//       //     })
//       //     .then(data => {
//       //         this.setState({ loadPanelVisible: false, currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
//       //         if (data != null && data.isSuccess) {
//       //             Swal.fire({
//       //                 html: "conference call added successfully",
//       //                 icon: "success",
//       //                 allowOutsideClick: false
//       //             });
//       //         } else {
//       //             console.log(data);
//       //             Swal.fire({
//       //                 html: "Failed to add conference call.. " + data.message,
//       //                 icon: "warning",
//       //                 allowOutsideClick: false
//       //             });
//       //         }
//       //     });

//       /*fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'AmeyoDialer/ConCallSession/' + userName, requestParams)
//                 .then(response => { if (response.ok) return response.json() })
//                 .then(data => {
//                     this.setState({ loadPanelVisible: false });
//                     if (data != null) {
//                         if (data.payload != null) {
//                             var result = data.payload;
//                             var ameyoUserId = result.ameyoUserId;
//                             var ameyoConferCallApiUrl = result.ameyoConferCallApiUrl;
//                             var conCallCampaignId = result.conCallCampaignId;
//                             var conCallCrtObjectId = result.conCallCrtObjectId;
//                             var conCallInitTime = result.conCallInitTime;
//                             var conCallPhoneNo = result.conCallPhoneNo;
//                             var conCallSessionId = result.conCallSessionId;
//                             var conCallUserCrtObjectId = result.conCallUserCrtObjectId;
//                             try {
//                                 var dataObj = new Object();
//                                 dataObj.campaignId = conCallCampaignId;
//                                 dataObj.userCRTObjectId = conCallUserCrtObjectId;
//                                 dataObj.phone = mobNo;
//                                 dataObj.requestId = ((new Date()).getTime() / 1000).toFixed()

//                                 const requestParams = {
//                                     method: 'POST',
//                                     mode: 'no-cors',
//                                     headers : {
//                                         "sessionId": conCallSessionId,
//                                         "Content-Type": "application/json",
//                                         */
      // },
      // body: JSON.stringify(dataObj)
      // }

      // fetch(ameyoConferCallApiUrl, requestParams)
      // .then(response => {
      // if (response.ok) {
      // return response.json()
      // }
      // else {
      // this.setState({ currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
      // }
      // })
      // .then(data => {
      // this.setState({ currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
      // if (data != null) {
      // var alertType = data.status != "error" ? "success" : "warning";
      // var message = data.status != "error" ? "conference call added successfully" : data.reason;
      // var timeout = data.status != "error" ? 2 : 5;
      // Swal.fire({
      // html: message,
      // icon: alertType,
      // allowOutsideClick: false
      // });
      // }
      // else {
      // Swal.fire({
      // html: "Failed to add conference call..",
      // icon: "warning",
      // allowOutsideClick: false
      // });
      // }
      // });
      // } catch (err) {
      // this.setState({ currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
      // Swal.fire({
      // html: "Failed to add conference call..",
      // icon: "warning",
      // allowOutsideClick: false
      // });
      // console.log("Error in " + this.displayName + ".ConCallSession function", err);
      // }
      // }
      // else {
      // this.setState({ currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
      // Swal.fire({
      // html: data.message,
      // icon: "error",
      // allowOutsideClick: false
      // });
      // }
      // }
      // else {
      // this.setState({ currentDialingMobNo: null, isDialing1: false, callingTypeDiv: false });
      // Swal.fire({
      // html: "Conference call settings not found.",
      // icon: "error",
      // allowOutsideClick: false
      // });
      // }
      // });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleConfigDialer function",
        err
      );
    }
  };

  getMarkerIconUrl = (status, course) => {
    let _course = course - (course % 5);
    if (status === "Moving") {
      return (
        "../assets/img/device-icons/Direction/Direction_green_" +
        _course +
        ".png?v=1.0"
      );
    } else if (status === "Stopped") {
      return (
        "../assets/img/device-icons/Direction/Direction_red_" +
        _course +
        ".png?v=1.0"
      );
    } else if (status === "Idle") {
      return (
        "../assets/img/device-icons/Direction/Direction_orange_" +
        _course +
        ".png?v=1.0"
      );
    } else {
      return (
        "../assets/img/device-icons/Direction/Direction_blue_" +
        _course +
        ".png?v=1.0"
      );
    }
  };

  getSeatIcon = (seatcOccupancy, index) => {
    return (
      "../assets/img/Seat-" + seatcOccupancy.split("|")[index] + ".png?v=1.0"
    );
  };

  render() {
    // console.log("this.state.vehicleDetails==>", this.state.vehicleDetails);
    // ac1Status
    // :
    // "0"
    // ac1Status_Display
    // :
    // "Off"
    // ac2Status
    // :
    // "1"
    // ac2Status_Display
    // :
    // "On"
    return (
      <Fragment>
        {this.state.vehicleDetails !== null && (
          <div
            className="vehicle-info"
            style={{ display: this.state.infoWindow }}
          >
            <div
              className="card rounded-vlg mb-0 shadow-lg rounded-vlg-border"
              id="mycard-dimiss"
            >
              <div className="card-header-action">
                <a
                  data-dismiss="#mycard-dimiss"
                  className="rounded-circle"
                  onClick={(e) => {
                    this.closeInfo(e);
                  }}
                  href="#"
                >
                  <i className="fas fa-times"></i>
                </a>
              </div>
              {this.state.showVehicleImage === true ? (
                <div className="vehicle-header">
                  <div
                    className="vehicle-image"
                    data-background={this.state.vehicleImage}
                  >
                    <img
                      src={this.state.vehicleImage}
                      width={100 + "%"}
                      alt={
                        this.state.vehicleDetails.vehicleType === null
                          ? "Vehicle"
                          : this.state.vehicleDetails.vehicleType
                      }
                    />
                  </div>
                </div>
              ) : null}
              <div className="card-body p-0">
                <h4
                  className={
                    this.state.showVehicleImage === true
                      ? this.state.hostStatusTitleClass
                      : this.state.hostStatusTitleClass +
                      " vehicle-info-visibility"
                  }
                >
                  <span className="text-white fw-bolder pull-left">
                    {this.state.vehicleDetails.vehicleNo}
                  </span>
                  <div
                    className={
                      this.state.showVehicleImage === true
                        ? "vehicle-datetime"
                        : "no-image-vehicle-datetime"
                    }
                  >
                    {formatDate(
                      this.state.vehicleDetails.deviceDateTime,
                      "dd/MMM/yyyy"
                    )}
                    <br />
                    {formatDate(
                      this.state.vehicleDetails.deviceDateTime,
                      "HH:mm:ss"
                    )}
                  </div>
                </h4>
                <div className="p-3">
                  {/*<span className="badge badge-primary float-right">{this.state.hostStatusTimeLabel}</span>*/}
                  <h6 className={this.state.hostStatusClass}>
                    {this.state.vehicleDetails.status}{" "}
                    {this.state.hostStatusTimeLabel}
                  </h6>
                  {this.state.vehicleDetails.hostStatus !== 4 && (
                    <span
                      className="card-link badge badge-dark ml-2 mb-2"
                      onClick={() => {
                        this.handleTrackVehicle();
                      }}
                    >
                      Track
                    </span>
                  )}
                  <p className="mb-0">
                    <img
                      alt="direction"
                      src={this.getMarkerIconUrl(
                        this.state.vehicleDetails.status,
                        this.state.vehicleDetails.course
                      )}
                    />{" "}
                    <span>{this.state.vehicleDetails.address}</span>
                  </p>
                  <p
                    className="mb-0"
                    style={{
                      display:
                        !this.state.ameyoIsActive &&
                          this.state.driverMobileShowHide
                          ? "block"
                          : "none",
                      paddingTop: "5px",
                    }}
                  >
                    <i className="fas fa-phone-alt"></i>&nbsp;&nbsp;
                    {this.state.vehicleDetails.driverMobileNo1}/&nbsp;
                    {this.state.vehicleDetails.driverMobileNo2}
                  </p>
                  <p
                    className="mb-0"
                    style={{
                      display:
                        this.state.ameyoIsActive &&
                          this.state.driverMobileShowHide
                          ? "block"
                          : "none",
                      paddingTop: "5px",
                    }}
                  >
                    <i
                      className={
                        this.state.isDialing1
                          ? "fas fa-solid fa-phone-volume"
                          : "fas fa-phone-alt"
                      }
                    ></i>
                    &nbsp;&nbsp;
                    <a
                      onClick={
                        this.state.isDialing1 == false &&
                        (() =>
                          this.handleClickOnMobileNo1(
                            this.state.vehicleDetails.driverMobileNo1
                          ))
                      }
                      style={{
                        marginRight: "9px",
                        display:
                          this.state.vehicleDetails.driverMobileNo1 != null
                            ? ""
                            : "none",
                      }}
                    >
                      <span
                        style={{
                          cursor: !this.state.isDialing1
                            ? "pointer"
                            : "not-allowed",
                          textDecoration: "underline",
                          color: !this.state.isDialing1 ? "blue" : "green",
                          fontWeight: this.state.isDialing1 ? "bold" : "",
                        }}
                      >
                        {this.state.vehicleDetails.driverMobileNo1}{" "}
                      </span>
                    </a>
                    <i
                      className={
                        this.state.isDialing2
                          ? "fas fa-solid fa-phone-volume"
                          : "fas fa-phone-alt"
                      }
                    ></i>
                    &nbsp;&nbsp;
                    <a
                      onClick={
                        this.state.isDialing2 == false &&
                        (() =>
                          this.handleClickOnMobileNo2(
                            this.state.vehicleDetails.driverMobileNo2
                          ))
                      }
                      style={{
                        display:
                          this.state.vehicleDetails.driverMobileNo2 != null
                            ? ""
                            : "none",
                      }}
                    >
                      <span
                        style={{
                          cursor: !this.state.isDialing2
                            ? "pointer"
                            : "not-allowed",
                          textDecoration: "underline",
                          color: !this.state.isDialing2 ? "blue" : "green",
                          fontWeight: this.state.isDialing2 ? "bold" : "",
                        }}
                      >
                        {this.state.vehicleDetails.driverMobileNo2}{" "}
                      </span>
                    </a>
                    &nbsp;&nbsp;
                  </p>
                  <p
                    className="mb-0"
                    style={{ display: this.state.callingTypeDiv ? "" : "none" }}
                  >
                    {/* <i className="fas fa-phone-square-alt" onClick={this.state.isDialing1 == false && (() => this.handleConfigDialer())} style={{ color: !this.state.isDialing1 ? 'green' : 'gray', cursor: !this.state.isDialing1 ? "pointer" : "not-allowed" }} ></i>&nbsp;&nbsp; */}
                    {/* <i onClick={this.state.isDialing1 == false && (() => this.handleConfigDialer())} className="fas fa-phone-alt" style={{ color: !this.state.isDialing1 ? 'green' : 'gray', cursor: !this.state.isDialing1 ? "pointer" : "not-allowed" }}></i> */}
                    <button
                      type="submit"
                      className="btn btn-success btn-sm"
                      onClick={
                        this.state.isDialing1 == false &&
                        ((e) => this.handleDialer(e))
                      }
                      title="Direct Call"
                      disabled={this.state.isDialing1 ? "disabled" : ""}
                      style={{ fontSize: "xx-small", padding: "0px" }}
                    >
                      <i
                        className="fas fa-phone-alt"
                        style={{ fontSize: "x-small" }}
                      ></i>
                      &nbsp;Direct Call
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="submit"
                      className="btn btn-success btn-sm"
                      onClick={
                        this.state.isDialing2 == false &&
                        ((e) => this.handleConfigDialer(e))
                      }
                      title="Conference Call"
                      disabled={this.state.isDialing2 ? "disabled" : ""}
                      style={{ fontSize: "xx-small", padding: "0px" }}
                    >
                      <i
                        className="fas fa-phone-alt"
                        style={{ fontSize: "x-small" }}
                      ></i>
                      &nbsp;Conference Call
                    </button>
                  </p>
                </div>
                <div
                  className="p-3"
                  style={{
                    display:
                      this.state.isDialing1 || this.state.isDialing2
                        ? "block"
                        : "none",
                  }}
                >
                  <p className="mb-0">
                    <i className="fas fa-phone-alt"></i> Calling....{" "}
                    {this.state.currentDialingMobNo}{" "}
                  </p>
                </div>
                <hr className="p-0 m-0" />
                <div
                  className="p-3"
                  style={{ display: this.state.infoVehicle }}
                >
                  <div className="row">
                    <div
                      className="col-4"
                      style={{
                        color: `${this.state.vehicleDetails.ac1Status > 0 ||
                            this.state.vehicleDetails.ac2Status > 0
                            ? "green"
                            : "#d2d2d2"
                          }`,
                      }}
                    >
                      <i className="far fa-snowflake"></i>
                      &nbsp;AC
                    </div>
                    <div className="col-4" style={{ color: "#d2d2d2" }}>
                      <i className="fas fa-tint"></i> Fuel
                    </div>
                    {/* <div
                      className="col-4"
                      style={{
                        color: this.state.vehicleDetails.immobilized
                          ? "green"
                          : "#d2d2d2",
                      }}
                    >
                      <i className="fas fa-retweet"></i> Mobilizer
                    </div> */}
                    <div className="col-4" style={{ color: "#d2d2d2" }}>
                      <i className="fas fa-cogs"></i> Engine
                    </div>
                    <div className="col-4" style={{ color: "#d2d2d2" }}>
                      <i className="fas fa-door-open"></i> Door
                    </div>
                    {this.state.vehicleDetails.isImmobilized > 0 && (
                      <div
                        className="col-4"
                        style={{
                          color:
                            this.state.vehicleDetails.immobilizationstatus ==
                              1 ||
                              this.state.vehicleDetails.immobilizationstatus == 0
                              ? "green"
                              : this.state.vehicleDetails
                                .immobilizationstatus === 4
                                ? "red"
                                : this.state.vehicleDetails
                                  .immobilizationstatus === 3
                                  ? "orange"
                                  : "gray",
                        }}
                      >
                        <a
                          className="card-link"
                          onClick={this.handleImmobilizerToggle}
                        >
                          <i className="fas fa-retweet"></i> Mobilizer
                        </a>
                      </div>
                    )}

                    {this.state.vehicleDetails.seatOccupancy != null &&
                      this.state.vehicleDetails.seatOccupancy != "" &&
                      this.state.vehicleDetails.seatOccupancy != "-" ? (
                      <div className="col-4" style={{ color: "#d2d2d2" }}>
                        <img
                          src={this.getSeatIcon(
                            this.state.vehicleDetails.seatOccupancy,
                            0
                          )}
                        ></img>
                        &nbsp;
                        <img
                          src={this.getSeatIcon(
                            this.state.vehicleDetails.seatOccupancy,
                            1
                          )}
                        ></img>
                        &nbsp;
                        <img
                          src={this.getSeatIcon(
                            this.state.vehicleDetails.seatOccupancy,
                            2
                          )}
                        ></img>{" "}
                        Seat
                      </div>
                    ) : null}
                  </div>
                </div>
                <div id="accordion" style={{ display: this.state.infoVehicle }}>
                  <div className="accordion mb-1">
                    <div
                      className="accordion-header"
                      role="button"
                      data-toggle="collapse"
                      data-target="#panel-body-1"
                    >
                      <h4>{VEHICLE_DETAILS_LABEL}</h4>
                      {this.state.vehicleDetails.vehicleCategory !== "" ? (
                        <span
                          style={{
                            position: "absolute",
                            top: "7px",
                            right: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          {this.state.vehicleDetails.vehicleCategory}
                        </span>
                      ) : null}
                    </div>
                    <div
                      className="accordion-body collapse p-0 m-0"
                      id="panel-body-1"
                      data-parent="#accordion"
                    >
                      <ul className="list-group">
                        {!isNullOrEmpty(
                          this.state.vehicleDetails.supervisorName
                        ) && (
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <span className="vinfo-title">
                                <i className="fas fa-user"></i>{" "}
                                {SUPERVISOR_NAME_LABEL}
                              </span>
                              <span className="float-right vinfo-text">
                                {this.state.vehicleDetails.supervisorName}
                              </span>
                            </li>
                          )}
                        {!isNullOrEmpty(
                          this.state.vehicleDetails.supervisorMobileNo
                        ) && (
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <span className="vinfo-title">
                                <i className="fas fa-phone-alt"></i>{" "}
                                {SUPERVISOR_MOBILE_NO_LABEL}
                              </span>
                              <span className="float-right vinfo-text">
                                {this.state.vehicleDetails.supervisorMobileNo}
                              </span>
                            </li>
                          )}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-tachometer-alt"></i> Odometer
                          </span>
                          <span className="float-right vinfo-text">
                            {this.state.vehicleDetails.odometer} km
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-tachometer-alt"></i> Speed
                          </span>
                          <span className="float-right vinfo-text">
                            {this.state.vehicleDetails.speed} kmph
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-road"></i> Today's KM
                          </span>
                          <span className="float-right vinfo-text">
                            {this.state.vehicleDetails.todayRunning} km
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-car-battery"></i> Battery Level
                          </span>
                          <span className="float-right vinfo-text">
                            <i
                              className={this.state.batteryPercentageClass}
                            ></i>
                            &nbsp;{this.state.vehicleDetails.batteryPercentage}%
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-stop-circle"></i> Last Stop KM
                          </span>
                          <span className="float-right vinfo-text">
                            {this.state.vehicleDetails.movingDistance} km since:{" "}
                            <Moment format="h:mm A">
                              {this.state.vehicleDetails.lastStopDateTime}
                            </Moment>
                          </span>
                        </li>
                        {this.state.fuelSensors.length > 0 &&
                          this.state.fuelSensors[0].fuelCalcTypeId !== 2 && (
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <span className="vinfo-title">
                                <i className="fas fa-tint"></i> Fuel
                              </span>
                              <span className="float-right vinfo-text">
                                <i className="fas fa-gas-pump"></i>&nbsp;
                                {this.state.vehicleDetails.fuelLevel == -0.01
                                  ? "N/A"
                                  : this.state.vehicleDetails.fuelLevel +
                                  " ltr"}
                              </span>
                            </li>
                          )}
                        {this.state.fuelSensors.length > 0 &&
                          this.state.fuelSensors[0].fuelCalcTypeId === 2 &&
                          this.state.fuelSensors.map((item) => (
                            <li
                              className="list-group-item d-flex justify-content-between align-items-center"
                              key={item.id}
                            >
                              <span className="vinfo-title">
                                <i className="fas fa-tint"></i>{" "}
                                {item.sensorName}
                              </span>
                              <span className="float-right vinfo-text">
                                <i className="fas fa-gas-pump"></i>&nbsp;
                                {this.state.vehicleDetails[item.fieldName] ==
                                  -0.01
                                  ? "N/A"
                                  : this.state.vehicleDetails[item.fieldName] +
                                  " ltr"}
                              </span>
                            </li>
                          ))}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-key"></i> Ignition Status{" "}
                          </span>
                          {/* <span className="float-right vinfo-text">{this.state.vehicleDetails.ignitionStatus}</span> */}
                          <span
                            className={
                              this.state.vehicleDetails.ignitionStatus === "On"
                                ? "badge-status badge-success-status float-right"
                                : "badge-status badge-danger-status float-right"
                            }
                          >
                            {this.state.vehicleDetails.ignitionStatus}
                          </span>
                        </li>
                        {/* {this.state.vehicleDetails.ac1Status > 0 && ( */}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="far fa-snowflake"></i> AC
                          </span>
                          <span
                            className={
                              this.state.vehicleDetails.ac1Status_Display ==
                                "On"
                                ? "badge-status badge-success-status float-right"
                                : "badge-status badge-danger-status float-right"
                            }
                          >
                            {this.state.vehicleDetails.ac1Status_Display == "On"
                              ? "On"
                              : "Off"}
                          </span>
                        </li>
                        {/* )} */}
                        {/* {this.state.vehicleDetails.ac2Status > 0 && (                           */}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="far fa-snowflake"></i> AC2
                          </span>
                          <span
                            className={
                              this.state.vehicleDetails.ac2Status_Display ==
                                "On"
                                ? "badge-status badge-success-status float-right"
                                : "badge-status badge-danger-status float-right"
                            }
                          >
                            {this.state.vehicleDetails.ac2Status_Display == "On"
                              ? "On"
                              : "Off"}
                          </span>
                        </li>
                        {/* )} */}

                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-plug"></i> Power Cable Status{" "}
                          </span>
                          <span
                            className={
                              this.state.vehicleDetails.powerCableStatus ===
                                "Connected"
                                ? "badge-status badge-success-status float-right"
                                : "badge-status badge-danger-status float-right"
                            }
                          >
                            {this.state.vehicleDetails.powerCableStatus}
                          </span>
                        </li>
                        {this.state.vehicleDetails.hasTempData && (
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-thermometer-half"></i> Temp:
                            </span>
                            <span className="float-right vinfo-text">
                              {this.state.vehicleDetails.temp1 !== 0
                                ? this.state.vehicleDetails.temp1 + " c"
                                : "N/A"}
                            </span>
                          </li>
                        )}
                        {this.state.vehicleDetails.hasTempData && (
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-thermometer-half"></i> Temp
                              2:
                            </span>
                            <span className="float-right vinfo-text">
                              {this.state.vehicleDetails.temp2 !== 0
                                ? this.state.vehicleDetails.temp2 + " c"
                                : "N/A"}
                            </span>
                          </li>
                        )}
                        {this.state.vehicleDetails.hasTempData && (
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-thermometer-half"></i> Temp
                              3:
                            </span>
                            <span className="float-right vinfo-text">
                              {this.state.vehicleDetails.temp3 !== 0
                                ? this.state.vehicleDetails.temp3 + " c"
                                : "N/A"}
                            </span>
                          </li>
                        )}
                        {this.state.vehicleDetails.hasTempData && (
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-thermometer-half"></i> Temp
                              4:
                            </span>
                            <span className="float-right vinfo-text">
                              {this.state.vehicleDetails.temp4 !== 0
                                ? this.state.vehicleDetails.temp4 + " c"
                                : "N/A"}
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className="accordion mb-0">
                    <div
                      className="accordion-header"
                      role="button"
                      data-toggle="collapse"
                      aria-expanded={
                        this.state.deviceTabOpen === "show" ? "true" : "false"
                      }
                      data-target="#panel-body-2"
                    >
                      <h4>Device & Trip Details</h4>
                    </div>
                    <div
                      className={
                        "accordion-body collapse p-0 m-0 " +
                        this.state.deviceTabOpen
                      }
                      id="panel-body-2"
                      data-parent="#accordion"
                    >
                      <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-map-marker-alt"></i> Lat-Long
                          </span>
                          <span className="float-right vinfo-text">
                            {this.state.vehicleDetails.latitude.toFixed(7)},
                            {this.state.vehicleDetails.longitude.toFixed(7)}{" "}
                          </span>
                        </li>
                        {!isNullOrEmpty(
                          this.state.vehicleDetails.inforCode
                        ) && (
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <span className="vinfo-title">
                                <i className="fas fa-car"></i> Infor Code
                              </span>
                              <span className="float-right vinfo-text">
                                {this.state.vehicleDetails.inforCode}
                              </span>
                            </li>
                          )}
                        {!isNullOrEmpty(
                          this.state.vehicleDetails.licensePlateNo
                        ) && (
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <span className="vinfo-title">
                                <i className="fas fa-car"></i> Reg. No
                              </span>
                              <span className="float-right vinfo-text">
                                {this.state.vehicleDetails.licensePlateNo}
                              </span>
                            </li>
                          )}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-map-marker-alt"></i>{" "}
                            {VEHICLE_DETAILS_LABEL_BASE_LOCATION}
                          </span>
                          <span className="float-right vinfo-text">
                            {subString2(
                              this.state.vehicleDetails.baseLocation,
                              25
                            )}
                          </span>
                        </li>
                        {!isNullOrEmpty(this.state.vehicleDetails.district) && (
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> District
                            </span>
                            <span className="float-right vinfo-text">
                              {this.state.vehicleDetails.district}
                            </span>
                          </li>
                        )}
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-mobile-alt"></i> Device Id
                          </span>
                          <span className="float-right vinfo-text">
                            {this.state.vehicleDetails.deviceImei}
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          <span className="vinfo-title">
                            <i className="fas fa-signal"></i> GPS Signal
                          </span>
                          <span className="float-right vinfo-text">
                            {this.state.vehicleDetails.gpsStatus}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {this.state.vehicleDetails.showButtonPanelTripEvents && (
                    <div className="accordion mb-2">
                      <div
                        className="accordion-header"
                        role="button"
                        data-toggle="collapse"
                        data-target="#panel-body-3"
                        style={{
                          backgroundColor: this.state.tripStatusBgColor,
                        }}
                      >
                        <h4 style={{ color: "#3e3e3e" }}>
                          {this.state.tripStatus +
                            " " +
                            this.state.tripStatusTimeDuration}
                        </h4>
                      </div>
                      <div
                        className="accordion-body collapse p-0 m-0"
                        id="panel-body-3"
                        data-parent="#accordion"
                      >
                        <ul className="list-group">
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> On Road
                            </span>
                            <span className={this.state.bpsOnRoadEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .onRoadEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .onRoadEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> Off Road
                            </span>
                            <span className={this.state.bpsOffRoadEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .offRoadEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .offRoadEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> Start
                              Trip
                            </span>
                            <span className={this.state.bpsStartEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .startTripEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .startTripEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> On Scene
                            </span>
                            <span className={this.state.bpsOnSceneEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .onSceneEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .onSceneEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> On Board
                            </span>
                            <span className={this.state.bpsOnBoardEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .onBoardEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .onBoardEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> Hosp In
                            </span>
                            <span className={this.state.bpsHosInEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .hospitalInEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .hospitalInEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> Hosp Out
                            </span>
                            <span className={this.state.bpsHosOutEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .hospitalOutEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .hospitalOutEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-map-marker-alt"></i> Clear
                            </span>
                            <span className={this.state.bpsClrEvent}>
                              {
                                this.state.vehicleButtonPanelStatus
                                  .clearEventTime
                              }{" "}
                              <small>
                                {
                                  this.state.vehicleButtonPanelStatus
                                    .clearEventTimeDur
                                }
                              </small>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                  {!this.state.vehicleDetails.showButtonPanelTripEvents && (
                    <div className="accordion mb-2">
                      <div
                        className="accordion-header"
                        role="button"
                        data-toggle="collapse"
                        data-target="#panel-body-3"
                        style={{
                          backgroundColor: this.state.tripStatusBgColor,
                        }}
                      >
                        <h4 style={{ color: "#3e3e3e" }}>
                          {this.state.tripStatus +
                            " " +
                            this.state.tripStatusTime}{" "}
                          <span style={{ lineHeight: "9px" }}>
                            {" "}
                            {this.state.tripStatusTimeDuration}
                          </span>
                        </h4>
                      </div>
                      <div
                        className="accordion-body collapse p-0 m-0"
                        id="panel-body-3"
                        data-parent="#accordion"
                      >
                        <ul className="list-group">
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-car"></i> Trip Status
                            </span>
                            <span className="float-right vinfo-text">
                              <strong>{this.state.tripStatus}</strong>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="fas fa-calendar-day"></i> Event Time
                            </span>
                            <span
                              className="float-right vinfo-text text-right"
                              style={{ lineHeight: "12px" }}
                              title={this.state.tripStatusTime}
                            >
                              {this.state.tripStatusTime}
                              <small style={{ lineHeight: "9px" }}>
                                <br />
                                {this.state.tripStatusTimeDuration}
                              </small>
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="vinfo-title">
                              <i className="far fa-snowflake"></i> Job Number
                            </span>
                            <span className="float-right vinfo-text">
                              {this.state.vehicleDetails.tripNo}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="custom-accord-header"
                  style={{ display: this.state.infoConfiguration }}
                >
                  <h4>
                    Configurations{" "}
                    <a
                      href="#"
                      className="card-link"
                      onClick={(e) => {
                        this.showInfoVehicle(e);
                      }}
                    >
                      <span className="float-right">
                        <i className="fas fa-chevron-left"></i> back
                      </span>
                    </a>
                  </h4>
                </div>
                <ul
                  className="list-group"
                  style={{ display: this.state.infoConfiguration }}
                >
                  <li className="list-group-item">
                    {/* This option is Disabled and new Mobilizer option enabled on main so hiding here from 05-Nov-2025  */}
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <span>
                          <i className="fas fa-tachometer-alt"></i> Output
                          Command
                        </span>
                      </div>
                      <div
                        className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right"
                        s
                      >
                        <span>
                          Set{" "}
                          <a
                            href="#"
                            title="Set Command"
                            onClick={(e) => {
                              this.showGpsCommandDiv(e);
                            }}
                            className="card-link"
                          >
                            <i className="fas fa-pen icon"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-8 col-md-8 col-sm-8 col-xs-8"
                        style={{ display: this.state.displayCommandDiv }}
                      >
                        <SelectBox
                          dataSource={this.state.gpsCommandList}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select Command"
                          name="commandID"
                          defaultValue={0}
                          value={this.state.gpsCommandId}
                          displayExpr="commandDescription"
                          valueExpr="commandID"
                          onSelectionChanged={this.handleGpsCommandChange}
                          showClearButton={true}
                          searchEnabled={true}
                        />
                      </div>
                      <div
                        className="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                        style={{ display: this.state.displayCommandDiv }}
                      >
                        <button
                          type="submit"
                          className="btn btn-success btn-sm btn-grow"
                          onClick={(e) => {
                            this.setDeviceGpsCommandType(e);
                          }}
                          title="Set Command"
                        >
                          <i className="fas fa-check"></i> Set
                        </button>
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                        <span>
                          <i className="fas fa-pen"></i> Change/Assign Driver
                        </span>
                      </div>
                      <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 text-right">
                        <span>
                          <a
                            href="#"
                            title="Change/Assign Driver"
                            onClick={(e) => {
                              this.showDriver(e);
                            }}
                            className="card-link"
                          >
                            Assign Driver <i className="fas fa-pen icon"></i>
                          </a>
                        </span>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <span>
                          <a
                            href="#"
                            title="Unassign Driver"
                            onClick={(e) => {
                              this.unassignDriver(e);
                            }}
                            className="card-link cbutton"
                          >
                            {this.state.vehicleDriverName != "Assign Driver" ? (
                              <i className="fas fa-times text-danger"></i>
                            ) : (
                              ""
                            )}
                            &nbsp;
                            {this.state.vehicleDriverName}
                          </a>
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-8 col-md-8 col-sm-8 col-xs-8"
                        style={{
                          display:
                            this.state.isShowDriver === true ? "block" : "none",
                        }}
                      >
                        <SelectBox
                          dataSource={this.state.dropdownDriver}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Driver"
                          name="id"
                          defaultValue={0}
                          value={this.state.driverId}
                          displayExpr="name"
                          valueExpr="id"
                          onSelectionChanged={this.handleDriverChange}
                          showClearButton={true}
                          visible={this.state.isShowDriver}
                          searchEnabled={true}
                        />
                      </div>
                      <div
                        className="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                        style={{
                          display:
                            this.state.isShowDriver === true ? "block" : "none",
                        }}
                      >
                        <button
                          type="submit"
                          className="btn btn-success btn-sm"
                          onClick={(e) => {
                            this.assignDriver(e);
                          }}
                          title="Change/Assign Driver"
                        >
                          <i className="fas fa-check"></i> Assign{" "}
                        </button>
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <span>
                          <i className="fas fa-plus"></i> Add Driver
                        </span>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                        <span>
                          <a
                            href="#"
                            title="Add Driver"
                            onClick={(e) => {
                              this.handleAddDriver(e);
                            }}
                            className="card-link"
                          >
                            Add Driver&nbsp;<i className="fas fa-plus icon"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <span>
                          <i className="fas fa-tachometer-alt"></i> Set
                          Overspeed Limit
                        </span>
                      </div>
                      <div
                        className={
                          this.state.isShowOverspeed === true
                            ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 text-left"
                            : "col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right"
                        }
                      >
                        <span
                          style={{
                            display:
                              this.state.isShowOverspeed === true
                                ? "block"
                                : "none",
                          }}
                        >
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="overSpeedLimit"
                            placeholder="Overspeed limit"
                            style={{ width: "50px" }}
                            maxLength="3"
                            title="Overspeed Limit"
                            value={this.state.overSpeedLimit}
                            onChange={(e) => {
                              this.handleInputChange(e);
                            }}
                          />
                        </span>
                        <span
                          style={{
                            display:
                              !this.state.isShowOverspeed === true
                                ? "block"
                                : "none",
                          }}
                        >
                          {this.state.overSpeedLimit}{" "}
                          <a
                            href="#"
                            title="Set Overspeed limit"
                            onClick={(e) => {
                              this.showVehicleOverspeed(e);
                            }}
                            className="card-link"
                          >
                            <i className="fas fa-pen icon"></i>
                          </a>
                        </span>
                      </div>
                      <div
                        className={
                          this.state.isShowOverspeed === true
                            ? "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            : ""
                        }
                        style={{
                          display:
                            this.state.isShowOverspeed === true
                              ? "block"
                              : "none",
                        }}
                      >
                        <button
                          type="submit"
                          className="btn btn-success btn-sm"
                          title="Set overspeed limit"
                          onClick={(e) => {
                            this.updateOverspeed(e);
                          }}
                        >
                          <i className="fas fa-check"></i> Set
                        </button>
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <span>
                          <i className="fas fa-palette"></i> Change Icons
                        </span>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                        <span>
                          {this.state.vehicleIcon}
                          <a
                            href="#"
                            title="Set Overspeed limit"
                            onClick={(e) => {
                              this.showVehicleIcon(e);
                            }}
                            className="card-link"
                          >
                            <i className="fas fa-pen icon"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-8 col-md-8 col-sm-8 col-xs-8"
                        style={{
                          display:
                            this.state.isShowVehicleIcon === true
                              ? "block"
                              : "none",
                        }}
                      >
                        <SelectBox
                          dataSource={this.state.dropdownVehicleIcon}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Icon"
                          name="id"
                          defaultValue={0}
                          value={this.state.vehicleIconId}
                          displayExpr="iconName"
                          valueExpr="id"
                          onSelectionChanged={this.handleVehicleIconChange}
                          showClearButton={true}
                          visible={this.state.isShowVehicleIcon}
                          searchEnabled={true}
                        />
                      </div>
                      <div
                        className="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                        style={{
                          display:
                            this.state.isShowVehicleIcon === true
                              ? "block"
                              : "none",
                        }}
                      >
                        <button
                          type="submit"
                          className="btn btn-success btn-sm"
                          onClick={(e) => {
                            this.updateVehicleIcon(e);
                          }}
                          title="Change Vehicle Icon"
                        >
                          <i className="fas fa-check"></i> Set
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
                <div
                  className="p-2"
                  style={{ display: this.state.infoVehicle }}
                >
                  <a
                    href="#"
                    className="card-link"
                    onClick={(e) => {
                      this.showInfoConfiguration(e);
                    }}
                  >
                    <i className="fas fa-cog"></i> Configurations
                  </a>
                  <a
                    className="card-link"
                    onClick={() => {
                      this.downloadVehicleActivityDetails(this.state.vehicleId);
                    }}
                  >
                    {this.state.isSubmited && (
                      <span title="In-process">
                        <i className="fas fa-spinner fa-spin"></i> In-process
                      </span>
                    )}
                    {!this.state.isSubmited && (
                      <span title="Donwload Activity">
                        <i className="fas fa-download"></i> Activity
                      </span>
                    )}
                  </a>
                  {/* <ExcelFile filename="Activity" fileExtension="xlsx" element={<a href="#" 
                                    onClick={e => e.preventDefault()} 
                                    style={{ cursor: 'hand' }} titke="Download Activity" className="card-link float-right"><i className="fas fa-download"></i> Download Activities</a>}>
                                    <ExcelSheet data={excelDataValues} name="Activity">
                                        <ExcelColumn label="Dairy Location" value="baseLocation" width="200px" />
                                        <ExcelColumn label="Transporter" value="transporter" /> 
                                        <ExcelColumn label="Vehicle No" value="vehicleNo" />
                                        <ExcelColumn label="Date" value="dateTime" style={excelStyle} />
                                        <ExcelColumn label="Status" value="status" />
                                        <ExcelColumn label="Event" value="event" />
                                        <ExcelColumn label="Speed" value="speed" />
                                        <ExcelColumn label="Odometer" value="odometer" />
                                        <ExcelColumn label="FuelLevel" value="fuelLevel" />
                                        <ExcelColumn label="Address" value="address" />
                                    </ExcelSheet>
                                </ExcelFile> */}
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal
          ariaHideApp={false}
          isOpen={this.state.immobilizerModalIsOpen}
          style={customStyles}
          className={"react-modal"}
          // onAfterOpen={this.handleAssignDataToState}
          // onRequestClose={this.handleResetStateData}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
        >
          <form
            method="post"
            // onSubmit={this.handleDriverSubmit}
            style={
              this.state.isSubmited
                ? { pointerEvents: "none", opacity: "0.4" }
                : {}
            }
          >
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <h6>
                    <label>
                      Do you Want to Set ?{" "}
                      <span className="text-danger">*</span> <br />
                    </label>
                  </h6>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-custom-gray"
                onClick={() => this.setState({ immobilizerModalIsOpen: false })}
                title="Close"
              >
                <i className="fas fa-times"></i> Close
              </button>
            </div>
          </form>
        </Modal>

        <Modal
          ariaHideApp={false}
          isOpen={this.state.driverModalIsOpen}
          style={customStyles}
          className={"react-modal"}
          onAfterOpen={this.handleAssignDataToState}
          onRequestClose={this.handleResetStateData}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
        >
          <form
            method="post"
            onSubmit={this.handleDriverSubmit}
            style={
              this.state.isSubmited
                ? { pointerEvents: "none", opacity: "0.4" }
                : {}
            }
          >
            <div className="modal-header">
              <h6 className="modal-title">
                {this.state.id > 0 ? "Modify  Driver " : "Add  Driver"}
              </h6>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.handleResetStateData}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      {" "}
                      Driver First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="driverName"
                      placeholder="Enter Driver First Name"
                      title="First Name"
                      value={this.state.driverName}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["driverName"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["driverName"]}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      {" "}
                      Driver Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="driverLName"
                      placeholder="Enter Driver Last Name"
                      title="Last Name"
                      value={this.state.driverLName}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["driverLName"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["driverLName"]}
                      </span>
                    )}
                  </div>
                </div>

                {/*              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      {" "}
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <NumberFormat
                      className="form-control"
                      name="mobileNumber1"
                      title="Mobile Number"
                        placeholder="1234567890"
                      format="##########"
                      value={this.state.mobileNumber1}
                                       onChange={(e) => this.handleInputChange(e)}

                    />
                    {this.state.errors["mobileNumber1"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["mobileNumber1"]}
                      </span>
                    )}
                  </div>
                </div>
                */}

                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      {" "}
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <NumberFormat
                      className="form-control"
                      name="mobileNumber2"
                      title="Mobile Number"
                      placeholder="1234567890"
                      format="##########"
                      value={this.state.mobileNumber2}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["mobileNumber2"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["mobileNumber2"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      Email
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Enter Email"
                      title="Email"
                      value={this.state.email}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["email"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["email"]}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      {" "}
                      Licence Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="licenceNumber"
                      placeholder="Enter Licence Number"
                      title="Licence Number"
                      value={this.state.licenceNumber}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["licenceNumber"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["licenceNumber"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      {" "}
                      Expire Date <span className="text-danger">*</span>{" "}
                    </label>
                    <DateBox
                      type="date"
                      className="form-control"
                      name="expDate"
                      placeholder="MM/dd/yyyy"
                      displayFormat="MM/dd/yyyy"
                      showAnalogClock={false}
                      useMaskBehavior={true}
                      defaultValue={this.state.expDate}
                      value={this.state.expDate}
                      onValueChanged={this.handleExpDateChange}
                      width="100%"
                      disabled={false}
                      acceptCustomValue={false}
                    />

                    {this.state.errors["expDate"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["expDate"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      Driver Key
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="driverKey"
                      placeholder="Enter Driver Key"
                      title="Driver Key"
                      value={this.state.driverKey}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["driverKey"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["driverKey"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      Address <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="address"
                      placeholder="Enter Address"
                      title="Address"
                      value={this.state.address}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["address"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["address"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      City <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="city"
                      placeholder="Enter City"
                      title="City"
                      value={this.state.city}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["city"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["city"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>
                      State <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="dState"
                      placeholder="Enter State"
                      title="State"
                      value={this.state.dState}
                      onChange={(e) => this.handleInputChange(e)}
                    />
                    {this.state.errors["dState"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["dState"]}
                      </span>
                    )}
                  </div>
                </div>
                {/* <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                  <div className="form-group" style={{ marginTop: "24px" }}>
                    <label>&nbsp;</label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isActive"
                        name="isActive"
                        checked={this.state.isActive}
                                             onChange={(e) => this.handleInputChange(e)}

                      />
                      <label className="form-group" htmlFor="isActive">
                        {" "}
                        Enable{" "}
                      </label>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={this.handleDriverSubmit}
                >
                  {this.state.isSubmited && (
                    <span title="In Process">
                      <i className="fas fa-spinner fa-spin"></i> In Process
                    </span>
                  )}
                  {!this.state.isSubmited && (
                    <span title="Submit">
                      <i className="fas fa-check"></i> Submit
                    </span>
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-custom-gray"
                  onClick={this.handleResetStateData}
                  title="Close"
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </div>
          </form>
        </Modal>
      </Fragment>
    );
  }
}
